import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { IoInformationCircleOutline } from "react-icons/io5";
import FundDetailsModal from "../FundDetailsModal";
import api from "../../../../utils/api";
import { formatRupees } from "../../../../utils/inputsValidation";
import { formatOrdinalDate } from "../../../../utils/formatOrdinalDate";
import moment from "moment";

export const FundEditModal = ({
  show,
  onHide,
  roomId,
  editRowData,
  defaultValues,
  isPortfolioData,
  openSipFormAllData,
  getClientreviewedfolio,
  fetchPortfolioData,
  onActionUpdate,
  rowKey,
  setIsActionMessage,
  amcName,
}) => {
  const [preData, setPreData] = useState({});
  const [generateSipForm, setGenerateSipForm] = useState({});

  const [actionName, setActionName] = useState("");
  const [minimumSTPInstallment, setMinimumSTPinstallment] = useState(1);
  const [bseMaximumPurchaseAmount, setBSEMaximumPurchaseAmount] = useState(0);
  // console.log(bseMaximumPurchaseAmount, 'bseMaximumPurchaseAmount');
  const preGoalName = openSipFormAllData?.goalName;


  const preGoalDetails = isPortfolioData?.goaldeatils?.[openSipFormAllData?.subId];
  console.log("generateSipForm898", preGoalDetails, openSipFormAllData);

  // console.log("editRowDataa", preData, preGoalDetails, openSipFormAllData);


  const [isLabel, setIsLabel] = useState({});

  // const [stpRedeemstartDate, setStpRedeemstartDate] = useState(null);
  const [stpRedeemstartDate1, setStpRedeemstartDate_1] = useState(null);
  const [stpRedeemstartDate2, setStpRedeemstartDate_2] = useState(null);

  const [showSipStopQuestion, setShowSipStopQuestion] = useState(false);
  const [sipStopAnswer, setSipStopAnswer] = useState("");

  const matchedAMC = Object.values(amcName)?.find(
    (amc) => amc.ISIN === openSipFormAllData?.ISIN
  );


  const [modalContent, setModalContent] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [stopSipSelection, setStopSipSelection] = useState({});

  const [amcNameList, setAmcNameList] = useState([]);

  const [restartSipFundList, setRestartSipFundList] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    setError,
    clearErrors,
    formState: { errors, isValid },
    setValue,
    watch,
    control,
  } = useForm({
    defaultValues: defaultValues || {},
    mode: "onChange",
  });

  const selectedAmcHouse = watch("amcHouseRedeem");

  const toggleStopSip = (id, enabled) => {
    setStopSipSelection((prev) => ({ ...prev, [id]: enabled }));
  };

  const clientreviewedfolioData = getClientreviewedfolio(
    preData?.portfolio_id,
    preData?.portfolio_ISIN
  );

  const ActionW = watch("sipaction");

  const allUnitsRedeemW = watch("allUnitsRedeem");
  const transactionAmountRedeemW = watch("transactionAmountRedeem");

  // -----------------Redeem-------------------
  const reInvestW = watch("reInvest");
  const goalNameRedeemW = watch("goalNameRedeem");
  const lumpSumAmountRedeemW = watch("lumpSumAmountRedeem");
  const amcHouseRedeemW = watch("amcHouseRedeem");
  const fundNameRedeemW = watch("fundNameRedeem");
  const redeem_stpW = watch("redeem_stp");
  const STP_FrequencyW = watch("STP_Frequency");
  const stpDurationMonthW = watch("stpDurationMonthRedeem");
  const STP_fundNameW = watch("STP_fundName");

  const redeem_stp1W = watch("redeem_stp1");
  const redeem_stp2W = watch("redeem_stp2");

  const STP_Frequency1W = watch("STP_Frequency1");
  const STP_Frequency2W = watch("STP_Frequency2");

  const stpdurationmonth1W = watch("stpdurationmonth1");
  const stpdurationmonth2W = watch("stpdurationmonth2");

  const STP_fundName1W = watch("STP_fundName1");
  const STP_fundName2W = watch("STP_fundName2");

  const stplumpsumamount1W = watch("stplumpsumamount1");
  const stplumpsumamount1W1 = watch("stplumpsumamount11");
  const stplumpsumamount1W2 = watch("stplumpsumamount12");

  // -----------------Switch-------------------
  const allUnitsSwitchW = watch("allUnitsSwitch");
  const transactionAmountSwitchW = watch("transactionAmountSwitch");
  const switchInFundW = watch("switchInFund");
  const stpSwitchW = watch("stpSwitch");
  const stpSwitchFrequencyW = watch("stpSwitchFrequency");
  const stpSwitchDurationW = watch("stpSwitchDuration");
  const stpSwitchlumpSumAmountW = watch("stpSwitchlumpSumAmount");
  const stpSwitchfundNameW = watch("stpSwitchfundName");


  const isRedeemStpAnswered = ["yes", "no"].includes(
    String(redeem_stpW ?? "").toLowerCase()
  );

  const isSwitchStpAnswered = ["yes", "no"].includes(
    String(stpSwitchW ?? "").toLowerCase()
  );
  // Get active SIPs (where to read them from)
  const activeSips =
    generateSipForm?.sipdata ??
    preData?.sipdata ??
    clientreviewedfolioData?.sipdata ??
    [];

  const selectedStopSipAmount = activeSips
    .filter(
      (sip) =>
        String(sip?.type).toLowerCase() === "online" &&
        stopSipSelection[sip._id]
    )
    .reduce(
      (total, sip) => total + (Number(sip?.sip_amount) || 0),
      0
    );

  const hasActiveOnlineSips =
    Array.isArray(activeSips) &&
    activeSips.some(
      (sip) => String(sip?.type).toLowerCase() === "online"
    );

  
  const showSipStopAfterStp =
    hasActiveOnlineSips &&
    (
      (ActionW === "Redeem" && isRedeemStpAnswered) ||
      (ActionW === "Switch" && isSwitchStpAnswered)
    );

  const sipStopText =
    showSipStopAfterStp && sipStopAnswer === "yes"
      ? ` Stop the existing SIP of ₹${selectedStopSipAmount}.`
      : "";
  console.log('activeSips', activeSips, generateSipForm?.sipdata, preData?.sipdata, clientreviewedfolioData?.sipdata);

  // console.log("isLable",generateSipForm?.sipdata,preData?.sipdata,clientreviewedfolioData?.sipdata, stopSipSelection, activeSips);

  // If the server includes pre-checked SIPs, initialize here:  
  // It cause Infinite loop
  // useEffect(() => {
  //   if (!activeSips || !Array.isArray(activeSips)) return;
  //   const init = {};
  //   activeSips.forEach((s) => {
  //     // default: unchecked
  //     init[s.id] = false;
  //   });
  //   setStopSipSelection(init);
  // }, [activeSips]);

  // useEffect(() => {
  //   // For auto set Lump Sum Amount according to Transaction Amount (Switch Amount) in Action Switch
  //   setValue("stpSwitchlumpSumAmount", tranAmountSwitch);
  // }, [tranAmountSwitch]);


  // -----------------STP-------------------
  const frequencySTPW = watch("frequencySTP");
  const durationSTPW = watch("durationSTP");
  const lumpSumAmountSTPW = watch("lumpSumAmountSTP");
  const stpInFundW = watch("stpInFund");

  useEffect(() => {
    if (fundNameRedeemW && amcNameList?.length > 0) {
      const selectedFund = amcNameList?.find(f => f?.fund_name === fundNameRedeemW);
      setBSEMaximumPurchaseAmount(Number(selectedFund?.BSE_Maximum_Purchase_Amount))
      console.log('amcHouseRedeemW', selectedFund, fundNameRedeemW,);
    }
  }, [reInvestW, selectedAmcHouse, fundNameRedeemW])

  // Get the selected STP In Fund object from AMC list
  // useEffect(() => {
  //   // console.log('stpInFund',)

  //   if (stpInFundW && generateSipForm?.switchfundlist?.length > 0) {
  //     const selectedFund = generateSipForm?.switchfundlist.find(fund => fund.fund_name === stpInFundW);
  //     if (selectedFund) {
  //       setMinimumSTPinstallment(selectedFund.STP_Minimum_Installment_Number_Monthly)
  //     }
  //   }
  // }, [stpInFundW, generateSipForm?.switchfundlist]);



  useEffect(() => {
    if (!stpInFundW) return;

    const fundList = generateSipForm?.switchfundlist;
    if (!Array.isArray(fundList) || fundList.length === 0) return;

    const selectedFund = fundList.find(fund => fund.fund_name === stpInFundW);
    if (!selectedFund) return;

    const minMonthly = Number(selectedFund.STP_Minimum_Installment_Number_Monthly || 0);
    setMinimumSTPinstallment(minMonthly);
    // if (frequencySTPW === "Weekly") {
    //   setMinimumSTPinstallment(minMonthly * 4);
    // } else {
    //   setMinimumSTPinstallment(minMonthly);
    // }
  }, [stpInFundW, frequencySTPW, generateSipForm]);


  // -----------------SIP-------------------
  const sipAmountSIPW = watch("sipAmountSIP");
  const goalNameSIPW = watch("goalNameSIP");
  const perpetualSIPW = watch("perpetualSIP");

  // -----------------SIP Stop-------------------
  const startasipW = watch("startasip");
  // rest same var from SIP
  const stopsip_amctW = watch("stopsip_amc");
  const restartfundnameW = watch("restartfundname");

  const [generateSipLoading, setGenerateSipLoading] = useState(false);

  useEffect(() => {
    // For auto set Lump Sum Amount according to Transaction Amount (Switch Amount) in Action Switch
    // setValue("stplumpsumamount1", lumpSumAmountRedeemW);
    if (ActionW !== "Redeem") return;
    if (reInvestW !== "yes") return;
    if (preData?.reinvest_lumpsumamt != null) {
      // console.log('lumpSumAmountRedeemW setValue', lumpSumAmountRedeemW);
      // already set from preData
      setValue("stplumpsumamount1", preData?.stp_lumpsum_amt);
    } else {
      console.log('lumpSumAmountRedeemW setValue', lumpSumAmountRedeemW);

      setValue("stplumpsumamount1", lumpSumAmountRedeemW);
    }
  }, [lumpSumAmountRedeemW]);

  useEffect(() => {
    clearErrors("stplumpsumamount");
    clearErrors("limpsuamt");
    clearErrors("stpdurationmonth");
    clearErrors("no_ofunites");
    clearErrors("STP_fundName");
    clearErrors("no_ofunites_switch");
    clearErrors("switchfund");

    clearErrors("lumpSumAmountSTP");
    clearErrors("stpDurationMonthRedeem");
    clearErrors("stplumpsumamount1");
    clearErrors("stpSwitchDuration");
    clearErrors("stplumpsumamount2");
    clearErrors("durationSTP");
    clearErrors("stpSwitchlumpSumAmount");

    clearErrors("stplumpsumamount1");
  }, [
    restartfundnameW,
    stopsip_amctW,
    stplumpsumamount1W1,
    stplumpsumamount1W2,
    durationSTPW,
    stpInFundW,
    lumpSumAmountSTPW,
    stpSwitchlumpSumAmountW,
    stpSwitchDurationW,
    lumpSumAmountRedeemW,
    stpDurationMonthW,
    transactionAmountRedeemW,
    transactionAmountSwitchW,
    STP_fundNameW,
    switchInFundW,
    stpDurationMonthW,
  ]);

  useEffect(() => {
    const isRestartingSip =
      (ActionW === "sip_stop" ||
        ((ActionW === "Switch" || ActionW === "Redeem") &&
          showSipStopAfterStp &&
          sipStopAnswer === "yes")) &&
      startasipW === "yes";

    const shouldSetGoalName =
      ActionW === "SIP" || isRestartingSip;

    if (!shouldSetGoalName) return;

    const goalName = preGoalName || preGoalDetails?.goalName || "";

    if (!goalName || goalName === "Unmapped") {
      setValue("goalNameSIP", "");
      return;
    }

    setValue("goalNameSIP", goalName, {
      shouldValidate: true,
    });
  }, [
    ActionW,
    preGoalName,
    preGoalDetails,
    showSipStopAfterStp,
    sipStopAnswer,
    startasipW,
    setValue,
  ]);

  const showFundDetails = async (fundName, goalName, preData, goalYea, startyear = new Date()) => {
    console.log("goalName", fundName, goalName, preData, openSipFormAllData);
    let goalYear = preData?.goalYear || ""

    // let goalYear = folio?.goal_folio_trans?.goalYear || ""


    setShowModal(true);
    try {
      const res = await api.post(
        `advisor/get_fund_by_name`,
        {
          fund_name: fundName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.data;

      if (!data || data.length === 0) return;

      const fund = data;
      console.log(' andfundName ', fund, fundName, goalName);

      if (
        fund.Whitelisted !== "true" ||
        fund.Time_Horizon === "Temporary Parking"
      ) {
        const errorMsg =
          fund.Whitelisted === "false"
            ? "Fund snapshots are only available for whitelisted funds"
            : "Fund Snapshots not available for Temporary Parking Funds";
        setModalContent(
          `<p class="text-danger text-center mt-3">${errorMsg}</p>`
        );
        return;
      }

      const currentYear = new Date().getFullYear();
      const goalDuration = goalYear - moment(startyear).format("YYYY");

      let rtn2 =
        goalDuration <= 1 ? "5 %" : goalDuration <= 3 ? "8 %" : goalDuration <= 4.99 ? "10 %" : goalDuration <= 6.99
          ? "12 %"
          : "13 %";

      let stmt2 = "";
      let rtnText = "";
      switch (fund.Time_Horizon) {
        case "1-3 Years":
          rtnText = "3 YEAR RETURN";
          stmt2 = "Short term focus is capital protection.";
          break;
        case "3-5 Years":
          rtnText = "5 YEAR RETURN";
          stmt2 = "Staggered entries work well here.";
          break;
        case "Above 5 Years":
          rtnText = "10 YEAR RETURN";
          stmt2 = "Invest monthly through SIPs or STPs.";
          break;
      }

      let SIRtn = fund.return_since_inception?.trim() || "Unavailable";

      if (!goalName?.toLowerCase().includes("goal")) goalName += " Goal";
      console.log("response 12 h", fund);

      const goalName2 = ["marriage", "graduation"].some((g) =>
        (goalName?.toLowerCase().includes(g))
          ? goalName
          : "Your " + goalName)
      // console.log("response goalName2 12 ", goalName2);

      let riskProfile = fund.Risk_Profile?.replace(" Funds", "") || "";
      riskProfile = (riskProfile === "Aggressive" ? "an " : "a ") + riskProfile;

      const html = `
          <div style="max-height: 800px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
            <div class="row">
              <div class="col-sm-2 text-center"><img src="/assets/images/fund-scheme.png" style="width: 6vw;"></div>
              <div class="col-sm-8 text-dark pt-3 text-center">
                <div style="font-size:1.7vw;"><strong>${goalName} | Year ${(goalYear || currentYear)
        }</strong></div>
                <div style="font-size: 1.3vw;">${fund.fund_name}</div>
              </div>
            </div><br>
            <div class="row text-center mb-3">
              <div class="col-sm-4 text-dark"><strong>FUND SIZE</strong><br><span class="text-success fs-5 fw-bold">${fund.fund_size
        }</span></div>
              <div class="col-sm-4 text-dark"><strong>INVESTMENT HORIZON</strong><br><span class="text-success fs-5 fw-bold">${fund.investment_horizon
        }</span></div>
              <div class="col-sm-4 text-dark"><strong>RETURN SINCE INCEPTION</strong><br><span class="text-success fs-5 fw-bold">${SIRtn}</span></div>
            </div>
            <div class="row d-flex justify-content-between text-center mb-3">
              <div class="col-sm-4 text-dark"><strong>CATEGORY</strong><br><span class="text-success fs-5 fw-bold">${fund.Sub_Category
        }</span></div>
              <div class="col-sm-4 text-dark"><strong>RETURN REQUIRED TO ACHIEVE GOAL</strong><br><span class="text-success fs-5 fw-bold">${rtn2}</span></div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-8">
                <div style="background: #fff1e8;border: .7vw solid #ffd1d1;min-height: 13vw;">
                  <span class="fs-5 fw-bold text-success">RECOMMENDATION RATIONALE</span>
                  <ul class="small mt-2 ms-3 text-justify">
                    ${[
          fund.rationale1,
          fund.rationale2,
          fund.rationale3,
          fund.rationale4,
          fund.rationale5,
        ]
          .map((r) => `<li>${r}</li>`)
          .join("")}
                  </ul>
                </div>
              </div>
              <div class="col-sm-4">
                <span class="fs-5 fw-bold text-success">SUMMARY</span>
                <img src="/assets/images/fund_scheme_bulb.png" style="width: 3.5vw;">
                <hr>
                <p style="font-size: 1vw;">${goalName} is ${(goalYear || currentYear) - currentYear
        } years away. We recommend ${riskProfile} fund like ${fundName}. ${stmt2}</p>
              </div>
            </div>
            <div>
            <span class="fs-5 fw-bold text-success">OUR PHILOSOPHY</span>
            <ul class="small mt-2 ms-3 text-justify text-dark">
                    ${[
          fund.philosophy1,
          fund.philosophy2,
          fund.philosophy3,
          fund.philosophy4,
          fund.philosophy5,
        ]
          .map((r) => `<li>${r}</li>`)
          .join("")}
                  </ul>
            </div>
          </div>
        `;

      setModalContent(html);
    } catch (err) {
      console.error(err);
      setModalContent(
        `<p class="text-danger text-center mt-3">Something went wrong</p>`
      );
    }
  };

  // Desired defaults (from preData / defaultValues)
  const desiredHouse = preData?.reinvest_amc
  const desiredFund = preData?.reinvest_fund
  const stopsipAmct = stopsip_amctW
  // 1) Modal open / house change par pehle AMC fund list lao
  useEffect(() => {
    if (!show) return;
    if (desiredHouse) {
      getAMCFundName(desiredHouse || stopsipAmct);   // yeh hi aapki API call hai
      setValue("amcHouseRedeem", desiredHouse, { shouldDirty: false });
      setValue('stopsip_amct', stopsipAmct)
    }
  }, [show, desiredHouse, stopsipAmct]);

  // 2) Jab list aa jaye aur usme desiredFund mil jaye, tabhi value set karo
  useEffect(() => {
    if (!show) return;
    if (!desiredFund) return;
    const hasFund = amcNameList?.some(f => f?.fund_name === desiredFund);
    if (hasFund) {
      setValue("fundNameRedeem", desiredFund, { shouldValidate: true, shouldDirty: false });
    }
  }, [show, amcNameList, desiredFund]);

  useEffect(() => {
    if (!show) return;
    // ek hi jagah form seed karo:
    reset({
      // jo fields aap set karna chahte ho:
      sipaction: preData?.action || "none",
      reInvest: preData?.is_reinvest || "",
      goalNameRedeem: preData?.investing_goal || preGoalName || "",
      lumpSumAmountRedeem: preData?.reinvest_lumpsumamt || "",
      amcHouseRedeem: desiredHouse || "",
      fundNameRedeem: desiredFund || "",
      // ...baaki jo bhi defaults hain
    }, { keepDirty: false, keepErrors: false });
  }, [show, preData, reset]);

  useEffect(() => {
    console.log(
      "qq",
      preData
      // generateSipForm,
      // preData?.stp_lumpsum_amt || generateSipForm?.currentval
    );

    if (preData?.action !== "none") {
      // --------Action-----------
      setValue("sipaction", preData?.action);

      // -----------------Redeem-------------------
      setValue("allUnitsRedeem", preData?.allunites);
      // setAllUnits(preData?.allunites);
      setValue("reInvest", preData?.is_reinvest);
      // setReInvest(preData?.is_reinvest);
      setValue("goalNameRedeem", preData?.investing_goal);
      setValue("transactionAmountRedeem", preData?.no_of_unites);
      setValue("lumpSumAmountRedeem", preData?.reinvest_lumpsumamt);
      setValue("amcHouseRedeem", preData?.reinvest_amc);
      setValue("fundNameRedeem", preData?.reinvest_fund);
      setValue("redeem_stp", preData?.is_stp);
      // setShowSTP(preData?.is_stp);
      setValue("redeem_stp1", preData?.is_stp1);
      setValue("redeem_stp2", preData?.is_stp2);
      setValue("STP_Frequency", preData?.stp_frequency || "");
      setValue("STP_Frequency1", preData?.stp_frequency1 || "");
      setValue("STP_Frequency2", preData?.stp_frequency2 || "");
      setValue("stpDurationMonthRedeem", preData?.stp_frequency == "Weekly" ? Number(preData?.stp_duration) / 4 : preData?.stp_duration);
      setValue("stpdurationmonth1", preData?.stp_frequency1 == "Weekly" ? Number(preData?.stp_duration1) / 4 : preData?.stp_duration1);
      setValue("stpdurationmonth2", preData?.stp_frequency2 == "Weekly" ? Number(preData?.stp_duration2) / 4 : preData?.stp_duration2);
      setValue("stplumpsumamount1", preData?.stp_lumpsum_amt);
      setValue("stplumpsumamount11", preData?.stp_lumpsum_amt1);
      setValue("stplumpsumamount12", preData?.stp_lumpsum_amt2);
      setValue("STP_fundName", preData?.stp_fundname);
      setValue("STP_fundName1", preData?.stp_fundname1);
      setValue("STP_fundName2", preData?.stp_fundname2);
      setValue("stpRedeemstartDate", preData?.stp_startdate);
      // setStpRedeemstartDate(preData?.stp_startdate);
      setStpRedeemstartDate_1(preData?.stp_startdate1);
      setStpRedeemstartDate_2(preData?.stp_startdate2);

      // ----------------- Switch ---------------
      setValue("allUnitsSwitch", preData?.allunites);
      // setAllUnits(preData?.allunites)
      setValue("transactionAmountSwitch", preData?.no_of_unites);
      setValue("stpSwitchFrequency", preData?.stp_frequency);
      setValue("switchInFund", preData?.switch_fund);
      // setSwitchInFund(preData?.switch_fund)
      setValue("stpSwitch", preData?.is_stp);

      setValue("stpSwitchDuration", preData?.stp_frequency == "Weekly" ? Number(preData?.stp_duration) / 4 : preData?.stp_duration);
      setValue("stpSwitchlumpSumAmount", preData?.stp_lumpsum_amt);
      setValue("stpSwitchfundName", preData?.stp_fundname);
      setValue("stpStartDateSwitch", preData?.stp_startdate);
      // setSelectedStartDateSwitch(preData?.stp_startdate)

      // -----------------SIP-------------------
      // setValue(sip_startdate)
      // setSelectedStartDate(preData?.sip_startdate)
      setValue("sipStartDate", preData?.sip_startdate);
      setValue("sipAmountSIP", preData?.sip_restart_amt);
      setValue("perpetualSIP", preData?.is_sip_perpetual || "yes");
      setValue("sipEndDate", preData?.sip_enddate);
      // setIsPerpetualSIP(preData?.is_sip_perpetual)
      // setSelectedEndDate(preData?.sip_enddate)

      // -----------------STP-------------------
      setValue("frequencySTP", preData?.stp_frequency);

      if (preData?.stp_frequency == "Weekly") {
        setValue("durationSTP", Number(preData?.stp_duration) / 4);
      } else {
        setValue("durationSTP", preData?.stp_duration);
      }
      // setValue("durationSTP", preData?.stp_duration);
      setValue("lumpSumAmountSTP", preData?.stp_lumpsum_amt);
      setValue("stpInFund", preData?.stp_fundname);
      setValue("stpStartDate", preData?.stp_startdate);
      // setSelectedStartDateSTP(preData?.stp_startdate);
      // Select STP Start Date remain

      // -----------------Stop SIP-------------------
      setValue("startasip", preData?.is_restartasip);
      setValue("stopsip_amc", preData?.sip_amc);
      setValue("restartfundname", preData?.sip_fundname);
      // stop_sips
      // activesips
    } else {

      setValue("sipaction", "none");
    }
  }, [preData, openSipFormAllData]);



  const [isSTP1Enabled, setIsSTP1Enabled] = useState(false);
  const [isSTP2Enabled, setIsSTP2Enabled] = useState(false);

  const [isStpSwitchDisabled, setIsStpSwitchDisabled] = useState(false);


  useEffect(() => {
    if (allUnitsSwitchW === "yes") {
      const currentVal = Number(generateSipForm?.currentval) || 0;
      const stp1 = Number(stpSwitchlumpSumAmountW) || 0;
      const stp2 = Number(stplumpsumamount1W1) || 0;

      // STP1: enable if currentVal > stp1
      setIsSTP1Enabled(currentVal > stp1);

      // STP2: enable if currentVal > (stp1 + stp2)
      setIsSTP2Enabled(currentVal > stp1 + stp2);
    } else if (allUnitsSwitchW === "no") {
      const currentVal = Number(generateSipForm?.currentval) || 0;

      const stp1 = (Number(transactionAmountSwitchW) + Number(stpSwitchlumpSumAmountW)) || 0;
      const stp2 = Number(stplumpsumamount1W1) || 0;
      setIsSTP1Enabled(currentVal > stp1);

      setIsSTP2Enabled(currentVal > stp1 + stp2);
    }
  }, [generateSipForm, stpSwitchlumpSumAmountW, transactionAmountSwitchW, stplumpsumamount1W1]);

  useEffect(() => {
    if (allUnitsSwitchW === "yes") {
      const currentVal = Number(generateSipForm?.currentval) || 0;
      setValue("stpSwitchlumpSumAmount", currentVal);
    } else if (allUnitsSwitchW === "no") {
      // let currentVal
      // if (preData?.no_of_unites !== null||preData?.no_of_unites !== undefined) {
      //   currentVal = Number(preData?.no_of_unites);
      // } else {
      //   currentVal = Number(generateSipForm?.currentval) || 0;
      // }
      // console.log("currentVal-1",currentVal,preData?.no_of_unites,generateSipForm?.currentval);


      // This replaces your entire if/else block
      const currentVal = Number(preData?.no_of_unites ?? generateSipForm?.currentval ?? 0);

      console.log("currentVal-Fixed:", currentVal);
      // setValue('transactionAmountSwitch', currentVal);

      setValue('transactionAmountSwitch', currentVal)
    }
  }, [allUnitsSwitchW])

  useEffect(() => {
    console.log('openSipFormAllDataa1', openSipFormAllData, preData?.stp_lumpsum_amt);

    if (!preData?.stp_lumpsum_amt) {
      setValue("lumpSumAmountSTP", openSipFormAllData?.currentval)
    }

    if (ActionW !== "Switch") return;

    let enteredVall;
    const currentVal = Number(generateSipForm?.currentval) || 0;

    if (allUnitsSwitchW === "no") {
      console.log('enteredVall', preData?.stp_lumpsum_amt);

      if (preData?.stp_lumpsum_amt != null) {
        enteredVall = Number(preData?.stp_lumpsum_amt);
        console.log('enteredValll', enteredVall);

        setValue("stpSwitchlumpSumAmount", enteredVall);


        if (redeem_stp2W === "yes") {
          if (preData?.stp_lumpsum_amt2 != null) {
            const minAmount1 = Number(preData?.stp_lumpsum_amt2);
            console.log('validateSwitchAmountall redeem_stp2W preData ', redeem_stp2W, enteredVall, stplumpsumamount1W2);
            setValue("stplumpsumamount12", minAmount1);
          } else {
            const minAmount1 = transactionAmountSwitchW - (enteredVall + (Number(stplumpsumamount1W1) || 0))
            console.log('validateSwitchAmountall redeem_stp2W ', redeem_stp2W, enteredVall, stplumpsumamount1W2);
            setValue("stplumpsumamount12", minAmount1);
          }
        }
        // console.log('validateSwitchAmountRun',currentVal,preData?.stp_lumpsum_amt,enteredVall);
      } else {
        console.log('validateSwitchAmount no ', preData?.stp_lumpsum_amt, currentVal - transactionAmountSwitchW);
        enteredVall = Number(preData?.stp_lumpsum_amt) || currentVal - transactionAmountSwitchW || 0;
        setValue("stpSwitchlumpSumAmount", enteredVall);
      }


    } else {
      // if all units yes 
      if (preData?.stp_lumpsum_amt != null) {
        enteredVall = Number(preData?.stp_lumpsum_amt);
        setValue("stpSwitchlumpSumAmount", enteredVall);
        // console.log('validateSwitchAmountall units yes ',currentVal,preData?.stp_lumpsum_amt,enteredVall);
      } else {
        // console.log('validateSwitchAmountall units yes stp_lumpsum_amt not avilable ',
        //   currentVal,preData?.stp_lumpsum_amt,enteredVall);
        setValue("stpSwitchlumpSumAmount", currentVal);
      }

    }

    const enteredVal = Number(transactionAmountSwitchW) || 0;
    const isPartial = allUnitsSwitchW === "no";

    // default
    // setValue("stpSwitch", "no");

    //  invalid when partial & entered >= current
    if (isPartial && enteredVal >= currentVal) {
      setValue("stpSwitch", "no");
      setError("stpSwitch", {
        type: "manual",
        message: "Transaction amount must be less than current value",
      });
      setIsStpSwitchDisabled(true);
      setValue("stpSwitchlumpSumAmount", ""); // clear rest
      return;
    }

    // ✅ valid
    clearErrors("stpSwitch");
    setIsStpSwitchDisabled(false);

    // if (isPartial && enteredVal > 0) {
    //   const restAmount = Math.max(currentVal - enteredVal, 0);
    //   // optional rounding: Number(restAmount.toFixed(2))
    //   setValue("stpSwitchlumpSumAmount", restAmount);
    // } else if (allUnitsSwitchW === "yes") {
    //   // (optional) full switch -> rest = current
    //   setValue("stpSwitchlumpSumAmount", currentVal);
    // } else {
    //   setValue("stpSwitchlumpSumAmount", "");
    // }

  }, [
    ActionW,
    allUnitsSwitchW,
    transactionAmountSwitchW,
    generateSipForm?.currentval,
    // redeem_stp1W,
    // redeem_stp2W,
    preData,
    setValue,
    setError,
    clearErrors,
  ]);

  useEffect(() => {
    if (redeem_stp1W === "yes") {
      if (preData?.stp_lumpsum_amt1 != null) {
        const minAmount1 = Number(preData?.stp_lumpsum_amt1);
        console.log('validateSwitchAmountall redeem_stp1W preData ', redeem_stp1W, stplumpsumamount1W1);
        setValue("stplumpsumamount11", minAmount1);
      } else {
        const minAmount1 = 0
        console.log('validateSwitchAmountall redeem_stp1W ', redeem_stp1W, stplumpsumamount1W1);
        setValue("stplumpsumamount11", minAmount1);
      }
    }
  }, [redeem_stp1W])

  useEffect(() => {
    if (ActionW === "") {
      setActionName("");
      return;
    }

    // ------------------ Redeem Logic ------------------
    if (ActionW === "Redeem") {
      if (allUnitsRedeemW === "yes") {
        if (reInvestW === "yes" && goalNameRedeemW && lumpSumAmountRedeemW) {
          setActionName(
            <div style={{ textAlign: "center" }}>
              Redeem All Units and then Re-Invest Rs.{lumpSumAmountRedeemW}
              {fundNameRedeemW && (
                <>
                  {" into "}
                  {fundNameRedeemW}
                  <IoInformationCircleOutline
                    className="ms-2"
                    onClick={() => showFundDetails(fundNameRedeemW, preData?.goal_name, preData)}
                    style={{ cursor: "pointer" }}
                  />
                  {" for  "}
                  {goalNameRedeemW}
                </>
              )}
              {redeem_stpW === "yes" && STP_FrequencyW && (
                <>
                  {`. Start a ${STP_FrequencyW} STP`}
                  {stpDurationMonthW && (
                    <>
                      {STP_FrequencyW === "Monthly" && (
                        <span>
                          {` of ₹${(
                            stplumpsumamount1W / stpDurationMonthW
                          ).toFixed(0)} for ${stpDurationMonthW} months`}
                        </span>
                      )}

                      {STP_FrequencyW === "Weekly" && (
                        <span>
                          {` of ₹${(
                            stplumpsumamount1W /
                            (stpDurationMonthW * 4)
                          ).toFixed(0)} for ${stpDurationMonthW}  months`}
                        </span>
                      )}
                      {STP_fundNameW && (
                        <>
                          {" into "}
                          {STP_fundNameW}
                          <IoInformationCircleOutline
                            className="ms-2"
                            onClick={() => showFundDetails(STP_fundNameW, preData?.goal_name, preData)}
                            style={{ cursor: "pointer" }}
                          />
                        </>
                      )}
                    </>
                  )}
                </>
              )}
              {"."}
              {/*STP2*/}
              {redeem_stp1W === "yes" && STP_Frequency1W && (
                <>
                  {console.log("redeem_stp1W", redeem_stp1W, STP_Frequency1W)}
                  {`. Start a ${STP_Frequency1W} STP`}
                  {stpdurationmonth1W && (
                    <>
                      {STP_Frequency1W === "Monthly" && (
                        <span>
                          {` of ${formatRupees(
                            stplumpsumamount1W1 / stpdurationmonth1W
                          )} for ${stpdurationmonth1W} months`}
                        </span>
                      )}

                      {STP_Frequency1W === "Weekly" && (
                        <span>
                          {` of ${formatRupees(
                            stplumpsumamount1W1 / (stpdurationmonth1W * 4)
                          )} for ${stpdurationmonth1W}  months`}
                        </span>
                      )}
                      {STP_fundName1W && ` into ${STP_fundName1W} `}
                      <IoInformationCircleOutline
                        className="ms-2"
                        onClick={() => showFundDetails(STP_fundName1W, preData?.goal_name, preData)}
                        style={{ cursor: "pointer" }}
                      />
                    </>
                  )}
                </>
              )}
              {/*STP3*/}
              {redeem_stp2W === "yes" && STP_Frequency2W && (
                <>
                  {`. Start a ${STP_Frequency2W} STP`}
                  {stpdurationmonth2W && (
                    <>
                      {STP_Frequency2W === "Monthly" && (
                        <span>
                          {` of ${formatRupees(
                            stplumpsumamount1W2 / stpdurationmonth2W
                          )} for ${stpdurationmonth2W} months`}
                        </span>
                      )}

                      {STP_Frequency2W === "Weekly" && (
                        <span>
                          {` of ${formatRupees(
                            stplumpsumamount1W2 / (stpdurationmonth2W * 4)
                          )} for ${stpdurationmonth2W}  months`}
                        </span>
                      )}
                      {STP_fundName2W && ` into ${STP_fundName2W} `}
                      <IoInformationCircleOutline
                        className="ms-2"
                        onClick={() => showFundDetails(STP_fundName2W, preData?.goal_name, preData)}
                        style={{ cursor: "pointer" }}
                      />
                    </>
                  )}
                </>
              )}
              {sipStopText}
            </div>
          );
          return;
        } else {
          setActionName("Redeem All Units.");
          return;
        }
      }

      if (allUnitsRedeemW === "no" && transactionAmountRedeemW) {
        setActionName(
          <div style={{ textAlign: "center" }}>
            Redeem Rs.{transactionAmountRedeemW}
            {reInvestW === "yes" && goalNameRedeemW && lumpSumAmountRedeemW && (
              <>
                {` and then Re-Invest Rs.${lumpSumAmountRedeemW}`}
                {fundNameRedeemW && (
                  <>
                    {" into "}
                    {fundNameRedeemW}
                    <IoInformationCircleOutline
                      className="ms-2"
                      onClick={() => showFundDetails(fundNameRedeemW, preData?.goal_name, preData)}
                      style={{ cursor: "pointer" }}
                    />
                    {" for "}
                    {goalNameRedeemW}
                  </>
                )}
                {redeem_stpW === "yes" && STP_FrequencyW && (
                  <>
                    {`. Start a ${STP_FrequencyW} STP`}
                    {stpDurationMonthW && (
                      <>
                        {STP_FrequencyW === "Monthly" && (
                          <span>
                            {` of ₹${(
                              stplumpsumamount1W / stpDurationMonthW
                            ).toFixed(0)} for ${stpDurationMonthW} months`}
                          </span>
                        )}

                        {STP_FrequencyW === "Weekly" && (
                          <span>
                            {` of ₹${(
                              stplumpsumamount1W /
                              (stpDurationMonthW * 4)
                            ).toFixed(0)} for ${stpDurationMonthW}  months`}
                          </span>
                        )}
                        {STP_fundNameW && ` into ${STP_fundNameW}`}
                      </>
                    )}
                  </>
                )}

                {/*STP2*/}
                {redeem_stp1W === "yes" && STP_Frequency1W && (
                  <>
                    {console.log("redeem_stp1W", redeem_stp1W, STP_Frequency1W)}
                    {`. Start a ${STP_Frequency1W} STP`}
                    {stpdurationmonth1W && (
                      <>
                        {STP_Frequency1W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / stpdurationmonth1W
                            )} for ${stpdurationmonth1W} months`}
                          </span>
                        )}

                        {STP_Frequency1W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / (stpdurationmonth1W * 4)
                            )} for ${stpdurationmonth1W}  months`}
                          </span>
                        )}
                        {STP_fundName1W && ` into ${STP_fundName1W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName1W, preData?.goal_name, preData)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
                {/*STP3*/}
                {redeem_stp2W === "yes" && STP_Frequency2W && (
                  <>
                    {`. Start a ${STP_Frequency2W} STP`}
                    {stpdurationmonth2W && (
                      <>
                        {STP_Frequency2W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / stpdurationmonth2W
                            )} for ${stpdurationmonth2W} months`}
                          </span>
                        )}

                        {STP_Frequency2W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / (stpdurationmonth2W * 4)
                            )} for ${stpdurationmonth2W}  months`}
                          </span>
                        )}
                        {STP_fundName2W && ` into ${STP_fundName2W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName2W, preData?.goal_name, preData)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {"."}
            {sipStopText}
          </div>
        );
        return;
      }
    }

    // ------------------ Switch Logic ------------------
    if (ActionW === "Switch") {
      if (allUnitsSwitchW === "yes") {
        setActionName(
          <div style={{ textAlign: "center" }}>
            Switch All Units
            {switchInFundW && (
              <>
                {" into "}
                {switchInFundW}
                <IoInformationCircleOutline
                  className="ms-2"
                  onClick={() => showFundDetails(switchInFundW, preData?.goal_name, preData)}
                  style={{ cursor: "pointer" }}
                />

                {stpSwitchW === "yes" && stpSwitchFrequencyW && (
                  <>
                    {`. Start a ${stpSwitchFrequencyW} STP`}
                    {stpSwitchDurationW && (
                      <>
                        {stpSwitchFrequencyW === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stpSwitchlumpSumAmountW / stpSwitchDurationW
                            )} for ${stpSwitchDurationW} months`}
                          </span>
                        )}

                        {stpSwitchFrequencyW === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stpSwitchlumpSumAmountW / (stpSwitchDurationW * 4)
                            )} for ${stpSwitchDurationW}  months`}
                          </span>
                        )}
                        {STP_fundNameW && ` into ${STP_fundNameW} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(stpSwitchfundNameW, preData?.goal_name, preData)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}

                {/*STP2*/}
                {redeem_stp1W === "yes" && STP_Frequency1W && (
                  <>
                    {console.log("redeem_stp1W", redeem_stp1W, STP_Frequency1W)}
                    {`. Start a ${STP_Frequency1W} STP`}
                    {stpdurationmonth1W && (
                      <>
                        {STP_Frequency1W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / stpdurationmonth1W
                            )} for ${stpdurationmonth1W} months`}
                          </span>
                        )}

                        {STP_Frequency1W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / (stpdurationmonth1W * 4)
                            )} for ${stpdurationmonth1W}  months`}
                          </span>
                        )}
                        {STP_fundName1W && ` into ${STP_fundName1W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName1W, preData?.goal_name, preData)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
                {/*STP3*/}
                {redeem_stp2W === "yes" && STP_Frequency2W && (
                  <>
                    {`. Start a ${STP_Frequency2W} STP`}
                    {stpdurationmonth2W && (
                      <>
                        {STP_Frequency2W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / stpdurationmonth2W
                            )} for ${stpdurationmonth2W} months`}
                          </span>
                        )}

                        {STP_Frequency2W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / (stpdurationmonth2W * 4)
                            )} for ${stpdurationmonth2W}  months`}
                          </span>
                        )}
                        {STP_fundName2W && ` into ${STP_fundName2W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName2W, preData?.goal_name, preData)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {"."}
            {sipStopText}
          </div>
        );
        return;
      }

      if (allUnitsSwitchW === "no" && transactionAmountSwitchW) {
        setActionName(
          <div style={{ textAlign: "center" }}>
            Switch Rs. {transactionAmountSwitchW}
            {switchInFundW && (
              <>
                {" into "}
                {switchInFundW}
                <IoInformationCircleOutline
                  className="ms-2"
                  onClick={() => showFundDetails(switchInFundW, preData?.goal_name, preData)}
                  style={{ cursor: "pointer" }}
                />

                {stpSwitchW === "yes" && stpSwitchFrequencyW && (
                  <>
                    {`. Start a ${stpSwitchFrequencyW} STP`}

                    {stpSwitchDurationW && (
                      <>
                        {stpSwitchFrequencyW === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stpSwitchlumpSumAmountW / stpSwitchDurationW
                            )} for ${stpSwitchDurationW} months`}
                          </span>
                        )}

                        {stpSwitchFrequencyW === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stpSwitchlumpSumAmountW / (stpSwitchDurationW * 4)
                            )} for ${stpSwitchDurationW}  months`}
                          </span>
                        )}
                        {STP_fundNameW && ` into ${STP_fundNameW} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(stpSwitchfundNameW, preData?.goal_name, preData)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}

                {/*STP2*/}
                {redeem_stp1W === "yes" && STP_Frequency1W && (
                  <>
                    {console.log("redeem_stp1W", redeem_stp1W, STP_Frequency1W)}
                    {`. Start a ${STP_Frequency1W} STP`}
                    {stpdurationmonth1W && (
                      <>
                        {STP_Frequency1W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / stpdurationmonth1W
                            )} for ${stpdurationmonth1W} months`}
                          </span>
                        )}

                        {STP_Frequency1W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / (stpdurationmonth1W * 4)
                            )} for ${stpdurationmonth1W}  months`}
                          </span>
                        )}
                        {STP_fundName1W && ` into ${STP_fundName1W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName1W, preData?.goal_name, preData)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
                {/*STP3*/}
                {redeem_stp2W === "yes" && STP_Frequency2W && (
                  <>
                    {`. Start a ${STP_Frequency2W} STP`}
                    {stpdurationmonth2W && (
                      <>
                        {STP_Frequency2W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / stpdurationmonth2W
                            )} for ${stpdurationmonth2W} months`}
                          </span>
                        )}

                        {STP_Frequency2W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / (stpdurationmonth2W * 4)
                            )} for ${stpdurationmonth2W}  months`}
                          </span>
                        )}
                        {STP_fundName2W && ` into ${STP_fundName2W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName2W, preData?.goal_name, preData)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {"."}
            {sipStopText}
          </div>
        );
        return;
      }
    }

    // ------------------ STP Logic ------------------
    if (ActionW === "STP" && frequencySTPW) {
      setActionName(
        <div style={{ textAlign: "center" }}>
          {`Start a ${frequencySTPW} STP`}
          {/* {durationSTPW && ` for ${durationSTPW} months`} */}
          {durationSTPW && (
            <>
              {frequencySTPW === "Monthly" && (
                <span>
                  {` of ${formatRupees(
                    lumpSumAmountSTPW / durationSTPW
                  )} for ${durationSTPW} months`}
                </span>
              )}

              {frequencySTPW === "Weekly" && (
                <span>
                  {` of ${formatRupees(
                    lumpSumAmountSTPW / (durationSTPW * 4)
                  )} for ${durationSTPW}  months`}
                </span>
              )}
              {STP_fundNameW && ` into ${STP_fundNameW} `}
              <IoInformationCircleOutline
                className="ms-2"
                onClick={() => showFundDetails(stpSwitchfundNameW, preData?.goal_name, preData)}
                style={{ cursor: "pointer" }}
              />
            </>
          )}
          {/* {lumpSumAmountSTPW && ` of Rs. ${lumpSumAmountSTPW}`} */}
          {stpInFundW && (
            <>
              {" into "}
              {stpInFundW}
              <IoInformationCircleOutline
                className="ms-2"
                onClick={() => showFundDetails(stpInFundW, preData?.goal_name, preData)}
                style={{ cursor: "pointer" }}
              />
            </>
          )}
          {"."}
          {sipStopText}
        </div>
      );
      return;
    }

    // ------------------ SIP Logic ------------------
    if (ActionW === "SIP" && goalNameSIPW && sipAmountSIPW) {
      setActionName(
        `Start a Monthly SIP of Rs. ${sipAmountSIPW} for ${goalNameSIPW}.`
      );
      return;
    }
    // ------------------ SIP Stp Logic ------------------
    const activesips = activeSips.reduce((acc, sip) => {
      if (stopSipSelection[sip._id]) {
        acc[sip._id] = sip.sip_amount;
      }
      return acc;
    }, {});
    const amounts = Object.values(activesips || {});
    const totalAmount = amounts.reduce((sum, amt) => sum + amt, 0);
    console.log('amounts', amounts, startasipW);

    if (ActionW === "sip_stop") {
      setActionName(
        <div>
          {`Stop the existing SIP  `}

          {amounts.length > 0 && (
            <>
              {/* {amounts.map((amt, i) => (
                <div key={i}>of Rs. {amt}</div>
              ))} */}
              <span>{`of ₹${amounts[0]}`}</span>
            </>
          )}
          {startasipW === "yes" && (
            <span> and Restart a Monthly SIP {' '}

              {sipAmountSIPW && `of Rs. ${sipAmountSIPW} for ${goalNameSIPW}`}
            </span>
          )}

          {fundNameRedeemW && (
            <>
              {" into "}
              {fundNameRedeemW}
              <IoInformationCircleOutline
                className="ms-2"
                onClick={() => showFundDetails(fundNameRedeemW, preData?.goal_name, preData)}
                style={{ cursor: "pointer" }}
              />
            </>
          )}
        </div>
      );
      return;
    }

    // Fallback
    setActionName("");
  }, [
    startasipW,
    redeem_stp2W,
    STP_Frequency2W,
    stpdurationmonth2W,
    stplumpsumamount1W2,
    STP_fundName2W,
    redeem_stp1W,
    STP_Frequency1W,
    stpdurationmonth1W,
    stplumpsumamount1W1,
    STP_fundName1W,
    ActionW,
    allUnitsRedeemW,
    transactionAmountRedeemW,
    reInvestW,
    goalNameRedeemW,
    lumpSumAmountRedeemW,
    fundNameRedeemW,
    redeem_stpW,
    STP_FrequencyW,
    stpDurationMonthW,
    STP_fundNameW,
    allUnitsSwitchW,
    transactionAmountSwitchW,
    switchInFundW,
    stpSwitchW,
    stpSwitchFrequencyW,
    stpSwitchDurationW,
    stpSwitchlumpSumAmountW,
    stpSwitchfundNameW,
    frequencySTPW,
    durationSTPW,
    lumpSumAmountSTPW,
    stpInFundW,
    goalNameSIPW,
    sipAmountSIPW,
    openSipFormAllData,
  ]);

  useEffect(() => {
    const minAmount = Number(matchedAMC?.BSE_Minimum_SIP_Amount);

    if (Number(transactionAmountRedeemW) < minAmount) {
      setError("transactionAmountRedeem", {
        type: "manual",
        message: `Minimum Amount should be ${minAmount} as allowed in ${openSipFormAllData?.schemename} `,
      });
    } else {
      clearErrors("transactionAmountRedeem");
    }
  }, [transactionAmountRedeemW, matchedAMC]);

  // Fetch AMC fund list from API

  // console.log("amcNameaaaa", amcName)

  // Fetch AMC fund names based on selected fund (investmentType)
  const getAMCFundName = async (fundName) => {
    try {
      const response = await api.get(
        `advisor/amc_fund_by_house?house_name=${fundName}`
      );
      setAmcNameList(response.data);
    } catch (error) {
      console.error("Error fetching AMC fund names:", error);
    }
  };

  // When the investmentType changes, get AMC Fund Name
  useEffect(() => {
    if (selectedAmcHouse || stopsip_amctW) {
      getAMCFundName(selectedAmcHouse || stopsip_amctW);
    }
  }, [selectedAmcHouse, stopsip_amctW]);



  function parsePortfolioOptions(optionsString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(optionsString, "text/html");
    const options = doc.querySelectorAll("option");

    let result = [];

    options.forEach((option) => {
      const valueParts = option.value.split("|");
      result.push({
        name: option.textContent.trim(),
        id: option.getAttribute("data-id"),
        targetYear: option.getAttribute("data-targetyear") || null,
        expectedReturn: option.getAttribute("data-Expectedreturn") || null,
        aum: option.getAttribute("data-aum") || null,
        runningSIP: option.getAttribute("data-runningSIP") || null,
        targetAmount: option.getAttribute("data-targetAmount") || null,
        requiredSIP: option.getAttribute("data-requiredSIP") || null,
      });
    });

    return result;
  }

  // console.log("hello", parsePortfolioOptions(isPortfolioData?.options?.options));

  const options = parsePortfolioOptions(isPortfolioData?.options?.options);

  // const defaultOption =
  //   options.find((opt) => opt.name === "Children’s Education")?.id || "";

  // useEffect(() => {
  //   if (defaultOption) {
  //     setValue("goalNameRedeem", defaultOption);
  //   }
  // }, [defaultOption, setValue]);

  console.info('generateSipForm-1', generateSipForm?.switchfundlist)

  useEffect(() => {
    fetchSIPForm();
  }, [openSipFormAllData]);

  const fetchSIPForm = async () => {
    if (!openSipFormAllData || Object.keys(openSipFormAllData)?.length === 0) {
      // console.warn('No data provided to fetch SIP form.');
      return;
    }

    let selectectedtext1 =
      openSipFormAllData?.schemename + " " + openSipFormAllData?.portfolioid;
    let selectectedtext2 =
      "Current Value:" + " " + formatRupees(openSipFormAllData?.currentval);
    setIsLabel({
      selectectedtext1,
      selectectedtext2,

    });
    setGenerateSipLoading(true);
    setPreData([])
    try {
      // console.log('Fetching SIP form with data:', openSipFormAllData);
      const response = await api.post(
        "advisor/generatesipform",
        {
          ...openSipFormAllData,
          sipaction: ActionW
        }
      );

      // console.log("SIP form generated successfully:", response.data);
      setGenerateSipLoading(false);

      setGenerateSipForm(response.data);
      setPreData(response.data?.clientreviewedfolio?.[0])
    } catch (error) {
      console.error("Error generating SIP form:", error);
      setGenerateSipLoading(true);
    }
  };

  const handleRedeemStartDateChange1 = (date) => {
    setStpRedeemstartDate_1(date);
  };
  const handleRedeemStartDateChange2 = (date) => {
    setStpRedeemstartDate_2(date);
  };


  // ------Helper Function For payload-------
  const is = (a, action) => action === a;
  const str = (v) => (v ?? "");
  const num = (v) => (v === "" || v == null ? "" : Number(v));

  function makePayload(action, data, generateSipForm = {}, extra = {}, test) {
    const {
      activesips = {},
      stp, stpfundName, duration, frequency,
      lumpSumAmount, startDate,
      stpRedeemstartDate1, stpRedeemstartDate2,
      invStartYear, invGoalYear, preGoalName,
    } = extra;

    const reinvestNo = data?.reInvest === "no";

    let selectedFund = "";
    let stpselectedFund = "";
    let stpselectedFund1 = "";
    let stpselectedFund2 = "";


    if (action == "STP") {
      selectedFund = generateSipForm?.switchfundlist?.find((item) => item?.fund_name === stpfundName);
      //  selectedFund = await getFund(stpfundName)
    } else if (action == 'sip_stop') {
    } else if (action == 'Redeem') {
      selectedFund = amcNameList.find((item) => item?.fund_name === data?.fundNameRedeem);
      stpselectedFund = amcNameList.find((item) => item?.fund_name === stpfundName);
      stpselectedFund1 = amcNameList.find((item) => item?.fund_name === data?.STP_fundName1);
      stpselectedFund2 = amcNameList.find((item) => item?.fund_name === data?.STP_fundName2);
    } else if (action == 'Switch') {
      selectedFund = (generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.switchInFund) || openSipFormAllData?.allSameFunds?.find((item) => item?.FundName === data?.switchInFund)
        || openSipFormAllData?.allSameFunds?.find((item) => item?.FundName === data?.switchInFund));

      stpselectedFund = generateSipForm?.switchfundlist.find((item) => item?.fund_name === stpfundName);
      stpselectedFund1 = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.STP_fundName1);
      stpselectedFund2 = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.STP_fundName2);
    }
    console.log("selectedFund", selectedFund);

    // else if(action== 'SIP'){

    //   selectedFund =  openSipFormAllData?.scheme_code||'tt';
    //   console.log('htt',openSipFormAllData?.scheme_code,action);
    // }

    // ---- Base (common) ----
    const payload = {
      // scheme_code:selectedFund?.scheme_code||"",
      // stp_scheme_code:stpselectedFund?.scheme_code||"",
      // stp_scheme_code1:stpselectedFund1?.scheme_code||"",
      // stp_scheme_code2:stpselectedFund2?.scheme_code||"",
      STP_fundName_sch_code: action == 'STP' ? selectedFund?.scheme_code || "" : stpselectedFund?.scheme_code || "",
      STP_fundName1_sch_code: stpselectedFund1?.scheme_code || "",
      STP_fundName2_sch_code: stpselectedFund2?.scheme_code || "",
      sipaction: str(action),
      pr_row_id: str(preData?.pr_row_id),
      schemename: str(generateSipForm.schemename),
      portfolioid: str(generateSipForm.portfolioid),
      currentval: str(generateSipForm.currentval),
      pan_client_id: str(generateSipForm.pan_client_id),
      clientid: str(generateSipForm.clientid),
      ISIN: str(generateSipForm.ISIN),
      isSIP: data?.sipaction === "Switch" ? 0 : (generateSipForm.isSIP ?? 0),
      moneyformatecurval: str(generateSipForm.moneyformatecurval),

      fundname: str(generateSipForm.fundname),
      startYear: str(invStartYear),
      goalYear: str(invGoalYear || generateSipForm.goalYear),
      goalNamePre: str(generateSipForm.goalName),
      goalIdPre: str(generateSipForm.goalId),

      isreviewed: 1,
      act: "submit",
      test: test,
    };

    // ---- STP----
    Object.assign(payload,
      is("STP", action) && {
        redeem_stp: str(stp),
        STP_Frequency: str(frequency),
        stpdurationmonth: str(duration),
        stplumpsumamount: num(lumpSumAmount),
        STP_fundName: str(stpfundName),
        // stp_sch_code:selectedFund?.scheme_code||"",

        stpstartdate: str(startDate),
        redeem_stp1: 'no',
        redeem_stp2: 'no',
      }
    );

    
    // ---- SIP STOP ----
    const shouldStopSip =
      is("sip_stop", action) ||
      (
        ["Redeem", "Switch"].includes(action) &&
        sipStopAnswer === "yes"
      );

    if (shouldStopSip) {
      const selectedActiveSips =
        Object.keys(activesips || {}).length > 0
          ? activesips
          : (activeSips || []).reduce((acc, sip) => {
            if (
              String(sip?.type).toLowerCase() === "online" &&
              stopSipSelection?.[sip._id]
            ) {
              acc[sip._id] = sip.sip_amount;
            }
            return acc;
          }, {});

      Object.assign(payload, {
        startasip: str(data?.startasip),
        stoptsip: "yes",
        restartfundname: str(data?.restartfundname),
        restartfundname_sch_code:
          amcNameList.find(
            (item) => item?.fund_name === data?.restartfundname
          )?.scheme_code || "",
        goalName: str(generateSipForm?.goalName),
        siprestartamount: num(data?.sipAmountSIP),
        stopsip_amc: str(data?.stopsip_amc),
        siprestartdate: str(data?.sipStartDate),
        siprePerpetual: str(data?.perpetualSIP),
        stopsip_enddate: str(data?.sipEndDate),
        activesips: selectedActiveSips,
      });
    }

    console.log("PAYLOAD AFTER SIP STOP", {
      action,
      shouldStopSip,
      reinvest: data?.reInvest,
      stp: payload.redeem_stp,
      stoptsip: payload.stoptsip,
      activesips: payload.activesips,
    });

    // Object.assign(payload,
    //   is("sip_stop", action) && {
    //     startasip: str(data.startasip),
    //     stoptsip: "yes",
    //     restartfundname: str(data.restartfundname),

    //     restartfundname_sch_code: selectedFund?.scheme_code || "",

    //     goalName: str(generateSipForm.goalName),

    //     siprestartamount: num(data.sipAmountSIP),
    //     stopsip_amc: str(data.stopsip_amc),
    //     siprestartdate: str(data.sipStartDate),
    //     siprePerpetual: str(data?.perpetualSIP),
    //     stopsip_enddate: str(data.sipEndDate),
    //     activesips,
    //   }
    // );

    // ---- Redeem ----
    Object.assign(payload,
      is("Redeem", action) && {
        allunites: str(data?.allUnitsRedeem),
        no_ofunites: data?.allUnitsRedeem === "no"
          ? num(data?.transactionAmountRedeem)
          : str(generateSipForm?.currentval),
        reinvest: str(data.reInvest),

        // cash-out ho to goal/fund blank
        goalName: reinvestNo ? "" : str(data?.goalNameRedeem || preGoalName),
        limpsuamt: reinvestNo ? "" : num(data.lumpSumAmountRedeem),
        selectfundhouse: reinvestNo ? "" : str(data?.amcHouseRedeem),
        selectfund: reinvestNo ? "" : str(data?.fundNameRedeem),
        selectfund_sch_code: selectedFund?.scheme_code || "",

        // STP only if reinvest !== "no"
        ...(reinvestNo ? {} : {
          redeem_stp: str(stp),
          STP_fundName: str(stpfundName),
          stpdurationmonth: str(frequency) === "Weekly" ? Number(duration) * 4 : Number(duration),
          STP_Frequency: str(frequency),
          stplumpsumamount: num(lumpSumAmount),
          stpstartdate: str(startDate),

          redeem_stp1: str(data.redeem_stp1 || "no"),
          STP_fundName1: str(data.STP_fundName1),
          stpdurationmonth1: str(data.STP_Frequency1) === "Weekly" ? Number(data.stpdurationmonth1) * 4 : Number(data.stpdurationmonth1),
          STP_Frequency1: str(data.STP_Frequency1),
          stplumpsumamount1: num(data.stplumpsumamount11),
          stpstartdate1: str(stpRedeemstartDate1),

          redeem_stp2: str(data.redeem_stp2 || "no"),
          STP_fundName2: str(data.STP_fundName2),
          stpdurationmonth2: str(data.STP_Frequency2) === "Weekly" ? Number(data.stpdurationmonth2) * 4 : Number(data.stpdurationmonth2),
          STP_Frequency2: str(data.STP_Frequency2),
          stplumpsumamount2: num(data.stplumpsumamount12),
          stpstartdate2: str(stpRedeemstartDate2),
        }),
      }
    );

    // ---- Switch ----
    Object.assign(payload,
      is("Switch", action) && {
        alluniteswitch: str(data.allUnitsSwitch),

        // agar partial switch ("no") hai → user amount lo
        // agar full switch hai → current value lo
        no_ofunites_switch:
          data?.allUnitsSwitch === "no"
            ? num(data?.transactionAmountSwitch)
            : str(generateSipForm?.currentval),

        switchfund: str(data.switchInFund),
        switchfund_sch_code: selectedFund?.scheme_code || "",

        swp_frequency: "",
        swp_amount: "",
        swp_startdate: "",
        swp_tenor: "",

        redeem_stp: str(stp), // yeh hamesha jayega (user ke choice ke hisaab se "yes"/"no")
      },

      // STP fields sirf tab jab redeem_stp === "yes"
      is("Switch", action) && {
        STP_fundName: str(stpfundName),
        stpdurationmonth: str(frequency) === "Weekly" ? Number(duration) * 4 : Number(duration),
        STP_Frequency: str(frequency),
        stplumpsumamount: num(lumpSumAmount),
        stpstartdate: str(startDate),

        // if stp = no → force no
        redeem_stp1: str(stp) === "yes" ? str(data.redeem_stp1 || "no") : "no",
        STP_fundName1: str(data.STP_fundName1),
        stpdurationmonth1: str(data.STP_Frequency1) === "Weekly" ? Number(data.stpdurationmonth1) * 4 : Number(data.stpdurationmonth1),
        STP_Frequency1: str(data.STP_Frequency1),
        stplumpsumamount1: num(data.stplumpsumamount11),
        stpstartdate1: str(stpRedeemstartDate1),

        // nested logic for redeem_stp2
        redeem_stp2:
          str(stp) === "no"
            ? "no" // if stp itself is no
            : str(data.redeem_stp1) === "no"
              ? "no" // if stp=yes but stp1=no
              : str(data.redeem_stp2 || "no"),
        STP_fundName2: str(data.STP_fundName2),
        stpdurationmonth2: str(data.STP_Frequency2) === "Weekly" ? Number(data.stpdurationmonth2) * 4 : Number(data.stpdurationmonth2),
        STP_Frequency2: str(data.STP_Frequency2),
        stplumpsumamount2: num(data.stplumpsumamount12),
        stpstartdate2: str(stpRedeemstartDate2),
      }
    );

    // ---- SIP (new) ----
    Object.assign(payload,
      is("SIP", action) && {
        scheme_code: openSipFormAllData?.scheme_code || '',
        sipfundname: str(generateSipForm.fundname),
        sip_sch_code: selectedFund?.scheme_code || "",
        goalName: preGoalName,
        goalNameStart: str(generateSipForm.goalName),
        sipfrequency: "Monthly",
        stoptsip: 'no',
        sipstartdate: str(data.sipStartDate),
        sipamount: num(data.sipAmountSIP),
        sipPerpetual: str(data?.perpetualSIP),
        sipenddate: str(data.sipEndDate),
        test: "SIP",
      }
    );

    return payload;
  }

  const onSubmit = async (data) => {

    console.log("ddata", data, preGoalDetails, generateSipForm);

    let invGoalName = preGoalName;
    let invGoalId = openSipFormAllData?.goalId;
    let invrunningSIP = preGoalDetails?.runningSIP || 0;
    let invCagr = Number(preGoalDetails?.expectedReturn) || 0;
    let invGoalYear = preGoalDetails?.goalYear || 0;
    let invStartYear = preGoalDetails?.startyear || 0;
    let invTargetAmount = Number(preGoalDetails?.TargetAmount) || 0;
    let invaum = Number(preGoalDetails?.accumulatedAmount) || 0;
    let action = data?.sipaction;
    let newSIP = parseInt(data.sipAmountSIP) || 0;

    const selectedActiveSips = (activeSips || []).reduce((acc, sip) => {
      if (
        String(sip?.type).toLowerCase() === "online" &&
        stopSipSelection?.[sip._id]
      ) {
        acc[sip._id] = sip.sip_amount;
      }

      return acc;
    }, {});

    const sipStopPayload =
      ["Redeem", "Switch"].includes(action) && sipStopAnswer === "yes"
        ? {
          startasip: str(data.startasip),
          stoptsip: "yes",
          restartfundname: str(data.restartfundname),
          restartfundname_sch_code:
            amcNameList.find(
              (item) => item?.fund_name === data.restartfundname
            )?.scheme_code || "",
          siprestartamount: num(data.sipAmountSIP),
          stopsip_amc: str(data.stopsip_amc),
          siprestartdate: str(data.sipStartDate),
          siprePerpetual: str(data.perpetualSIP),
          stopsip_enddate: str(data.sipEndDate),
          activesips: selectedActiveSips,
        }
        : {};
    // console.log('invGoalYear',invGoalYear,invStartYear);

    let no_ofunites = 0;
    // let remainingMonth = (invGoalYear - invStartYear) * 12;

    const currentYear = new Date().getFullYear();

    const yearsRemaining = Math.max(invGoalYear - currentYear, 0);


    // if SIP starts now, use currentYear as base
    let remainingMonth;
    if (currentYear > invStartYear) {
      remainingMonth = (invGoalYear - currentYear) * 12;
    } else {
      remainingMonth = (invGoalYear - invStartYear) * 12;
    }

    if (action == "SIP") {
      // let oneTimeInvFutureVal = invaum * Math.pow(1 + invCagr / 100, invGoalYear - invStartYear);
      let oneTimeInvFutureVal = invaum * Math.pow(1 + invCagr / 100, yearsRemaining);

      let capitalGrowth = 0;
      let monthEndValue = 0,
        finalCorpus = 0;
      let totalSIP = invrunningSIP + newSIP;

      monthEndValue = monthEndValue + totalSIP;
      finalCorpus = Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);
      console.log('finalCorpus', finalCorpus, oneTimeInvFutureVal)
      // console.log('invGoalYear', monthEndValue, oneTimeInvFutureVal, invrunningSIP, newSIP, invGoalYear,
      //   invStartYear, invaum, invCagr,
      //   invGoalYear, invStartYear,
      // );

      // console.log(
      //   "SIPpo",
      //   invGoalYear,2035
      //   invrunningSIP,0
      //   invCagr,14
      //   invStartYear,2025
      //   invTargetAmount,1000000
      //   invaum,83668
      //   monthEndValue,4444
      //   oneTimeInvFutureVal ,310175
      // );

      if (finalCorpus < invTargetAmount) {
        // const allData = {
        //   stoptsip: "",
        //   startasip: "",
        //   sipaction: action || "",
        //   allunites: data?.allUnitsRedeem || "",
        //   no_ofunites: data?.transactionAmountRedeem || "",
        //   reinvest: "",
        //   goalName: invGoalName || "",
        //   limpsuamt: "",
        //   selectfundhouse: data.amcHouseRedeem || "",
        //   selectfund: data.fundNameRedeem || "",
        //   lumpsuamtount: "",
        //   selectfundlumpsum: "",

        //   alluniteswitch: data.allUnitsSwitch || "",
        //   no_ofunites_switch: "",
        //   switchfund: data.switchInFund || "",
        //   swp_frequency: "",
        //   swp_amount: "",
        //   swp_startdate: "",
        //   swp_tenor: "",
        //   redeem_stp: data.stp || "",
        //   STP_Frequency: data.frequencySTP || data.stpSwitchFrequency || "",
        //   stplumpsumamount: "",
        //   stpdurationmonth:
        //     data.durationSTP || data.stpDurationMonthRedeem || "",
        //   STP_fundName: "",

        //   sipfundname: "",
        //   goalNameStart: generateSipForm?.goalName || "",
        //   siprestartdate: data.sipStartDate || "",
        //   siprestartamount: data.sipAmountSIP || "",
        //   siprePerpetual: data?.perpetualSIP || "",
        //   sipfrequency: "Monthly",
        //   stopsip_enddate: data.sipEndDate || "",

        //   // selectedStartDate ||
        //   stpstartdate: "",
        //   isreviewed: 1,

        //   siptypeaction: data?.sipaction || "",
        //   schemename: generateSipForm?.schemename || "",
        //   portfolioid: generateSipForm?.portfolioid || "",
        //   currentval: generateSipForm?.currentval || "",
        //   clientid: generateSipForm?.clientid || "",
        //   ISIN: generateSipForm?.ISIN || "",
        //   isSIP: generateSipForm?.isSIP || "",
        //   moneyformatecurval: generateSipForm?.moneyformatecurval || "",

        //   fundname: generateSipForm?.fundname || "",

        //   startYear: invStartYear || "",
        //   goalYear: invGoalYear || "",
        //   goalNamePre: generateSipForm?.goalName || "",
        //   goalIdPre: generateSipForm?.goalId || "",
        //   act: "submit",
        //   test: "test2",
        // };

        let stp = "yes";
        let frequency = data.frequencySTP;
        let duration = data.durationSTP;
        let lumpSumAmount = data.lumpSumAmountSTP;
        let stpfundName = data.stpInFund;
        let startDate = data.stpStartDate;

        const allData = makePayload(action, data, generateSipForm, {
          stp, stpfundName, duration, frequency,
          lumpSumAmount, startDate,
          stpRedeemstartDate1, stpRedeemstartDate2,
          invStartYear, invGoalYear, preGoalName,
        }, 'test3');
        console.log('allData', allData);

        // sip allowed
        try {
          if (
            data?.sipaction === "Redeem" &&
            data?.allUnitsRedeem === "no"
          ) {
            const redeemAmount = Number(data?.transactionAmountRedeem);
            const currentValue = Number(generateSipForm?.currentval);

            if (
              data?.transactionAmountRedeem === "" ||
              !Number.isFinite(redeemAmount) ||
              !Number.isFinite(currentValue) ||
              redeemAmount <= 0 ||
              redeemAmount > currentValue
            ) {
              setError("transactionAmountRedeem", {
                type: "manual",
                message:
                  !Number.isFinite(currentValue)
                    ? "Current fund value is unavailable."
                    : redeemAmount > currentValue
                      ? `Redemption amount cannot exceed the current value of ₹${currentValue.toLocaleString("en-IN")}.`
                      : "Enter a valid redemption amount greater than zero.",
              });

              return;
            }
          }
          const response = await api.post(`advisor/saveportfolio`, allData);
          console.log("saveportfolio", response.data);
          if (
            response.data.status === false &&
            response.data.errors &&
            Object.keys(response.data.errors).length > 0
          ) {
            console.log("saveportfolio", response.data);

            if (response.data.errors.no_ofunites) {
              setError("transactionAmountRedeem", {
                type: "manual",
                message: response.data.errors.no_ofunites,
              });
            } else {
              clearErrors("transactionAmountRedeem");
            }
            // Add more fields as needed
          } else if (response.data.message !== "") {
            onHide(true);
            Swal.fire({
              title: "Success",
              icon: "success",
              html: response.data.message,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "swal-confirm-btn",
              },
            }).then(() => {
              // setIsActionMessage(response.data.message);

              // Inside FundEditModal, after API success
              onActionUpdate(
                rowKey,
                response.data.message,
                response.data.scheme_code
              );
              // onActionSchemeCode(rowKey, response.data.scheme_code);

              // fetchPortfolioData(); // 🔄 Refresh portfolio data
              // resetModalStates(); // 🧹 Reset form & state
            });
          }
        } catch (error) {
          console.error("Error fetching generatesipform data:", error.data);
        }
      } else {
        var diff = finalCorpus - invTargetAmount;
        // console.log('gg-2', finalCorpus, diff, invTargetAmount);

        Swal.fire({
          title: "Oops! Exceeds Goal Target!",
          text: `This investment will bring the projected achievement to ${finalCorpus}, which is ${diff} 
          higher than the Goal Target of ${invTargetAmount}.`,
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
      }
    } else if (data.reinvest === "yes") {
      let aum;
      // remainingMonth = (invGoalYear - invStartYear) * 12;

      var reinvest = data.reinvest;
      if (reinvest == "yes" && invGoalName === "") {
        Swal.fire({
          text: "Please Select a Goal to Invest",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
        return false;
      } else {
        let newSIP = 0;
        if (generateSipForm?.goalId == invGoalId) {
          if (data.allUnitsRedeem === "yes") {
            aum = Math.round(data.lumpSumAmountRedeem);
          } else {
            invaum =
              invaum - no_ofunites + Math.round(data.lumpSumAmountRedeem);
          }
          let oneTimeInvFutureVal =
            invaum * Math.pow(1 + invCagr / 100, invGoalYear - invStartYear);
          let capitalGrowth = 0;
          let monthEndValue = 0,
            finalCorpus = 0;
          let totalSIP = invrunningSIP + newSIP;
          for (var i = 1; i < remainingMonth; i++) {
            capitalGrowth = ((monthEndValue + totalSIP) * invCagr) / 1200;
            monthEndValue = monthEndValue + capitalGrowth + totalSIP;
          }
          monthEndValue = monthEndValue + totalSIP;
          finalCorpus =
            Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);
          if (finalCorpus < invTargetAmount) {

            let selectedFund = "";
            let stpselectedFund = "";
            let stpselectedFund1 = "";
            let stpselectedFund2 = "";


            if (action == "STP") {
              // selectedFund = generateSipForm?.switchfundlist?.find((item) => item?.fund_name === stpfundName);
              //  selectedFund = await getFund(stpfundName)
            } else if (action == 'sip_stop') {
            } else if (action == 'Redeem') {
              selectedFund = amcNameList.find((item) => item?.fund_name === data?.fundNameRedeem);
              stpselectedFund = amcNameList.find((item) => item?.fund_name === data?.STP_fundName);
              stpselectedFund1 = amcNameList.find((item) => item?.fund_name === data?.STP_fundName1);
              stpselectedFund2 = amcNameList.find((item) => item?.fund_name === data?.STP_fundName2);
            }
            else if (action == 'Switch') {
              selectedFund = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.switchInFund);
              stpselectedFund = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.STP_fundName);
              stpselectedFund1 = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.STP_fundName1);
              stpselectedFund2 = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.STP_fundName2);
            }
            // else if(action== 'SIP'){

            //   selectedFund =  openSipFormAllData?.scheme_code||'tt';
            //   console.log('htt',openSipFormAllData?.scheme_code,action);
            // }

            const allData = {
              // scheme_code:selectedFund?.scheme_code||"",
              // stp_scheme_code:stpselectedFund?.scheme_code||"",
              // stp_scheme_code1:stpselectedFund1?.scheme_code||"",
              // stp_scheme_code2:stpselectedFund2?.scheme_code||"",

              selectfund_sch_code: selectedFund?.scheme_code || "",
              STP_fundName_sch_code: stpselectedFund?.scheme_code || "",
              STP_fundName1_sch_code: stpselectedFund1?.scheme_code || "",
              STP_fundName2_sch_code: stpselectedFund2?.scheme_code || "",

              sipaction: action,
              allunites: data?.allUnitsRedeem,
              no_ofunites: 0,
              reinvest: data.reInvest,
              goalName: invGoalName,
              limpsuamt: data.lumpSumAmountRedeem || "",
              selectfundhouse: data.amcHouseRedeem,
              selectfund: data.fundNameRedeem,
              lumpsuamtount: "",
              selectfundlumpsum: "",

              alluniteswitch: data.allUnitsSwitch,
              no_ofunites_switch: "",
              switchfund: data.switchInFund,
              swp_frequency: "",
              swp_amount: "",
              swp_startdate: "",
              swp_tenor: "",
              redeem_stp: data.stp,
              STP_Frequency: data.frequencySTP || data.stpSwitchFrequency,
              stplumpsumamount: "",
              stpdurationmonth: frequencySTPW === "Weekly" ? Number(data.durationSTP) * 4 || Number(data.stpDurationMonthRedeem) * 4 : data.durationSTP || data.stpDurationMonthRedeem,
              STP_fundName: data.switchInFund || "",

              sipfundname: "",
              goalNameStart: generateSipForm?.goalName,
              // selectedStartDate ||
              sipstartdate: "",
              sipamount: data.sipAmountSIP,
              sipfrequency: "Monthly",
              sipPerpetual: "",
              sipenddate: "",

              // selectedStartDate ||
              stpstartdate: "",
              isreviewed: 1,

              siptypeaction: data?.sipaction,
              ...sipStopPayload,
              schemename: generateSipForm?.schemename,
              portfolioid: generateSipForm?.portfolioid,
              currentval: generateSipForm?.currentval,
              pan_client_id: str(generateSipForm.pan_client_id),
              clientid: generateSipForm?.clientid,
              ISIN: generateSipForm?.ISIN,
              isSIP: generateSipForm?.isSIP,
              moneyformatecurval: generateSipForm?.moneyformatecurval,

              fundname: generateSipForm?.fundname,
              startYear: invStartYear,
              goalYear: invGoalYear,
              goalNamePre: generateSipForm?.goalName,
              goalIdPre: generateSipForm?.goalId,
              act: "submit",
              test: "test1",
            };

            try {
              const response = await api.post(`advisor/saveportfolio`, allData);
              console.log("saveportfolio", response.data);
              if (response.data.message !== "") {
                Swal.fire({
                  title: "Success",
                  text: response.data.message,
                  icon: "success",
                  confirmButtonText: "OK",
                  customClass: {
                    confirmButton: "swal-confirm-btn",
                  },
                });
              }


            } catch (error) {
              console.error("Error fetching generatesipform data:", error.data);
            }
          } else {
            var diff = finalCorpus - invTargetAmount;

            Swal.fire({
              title: "Oops! Cannot exceed Goal Target",
              text:
                "This investment will take the projected achievement to " +
                finalCorpus +
                ", which is " +
                diff +
                " higher than the Goal Target of " +
                invTargetAmount +
                ".",
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "swal-confirm-btn",
              },
            });
            return false;
          }
        } else {
          let aum = Math.round(data.lumpSumAmountRedeem);
          let invrunningSIP = invrunningSIP || 0;
          let targetAmountt = 0;

          if (
            typeof invTargetAmount !== "undefined" &&
            invTargetAmount !== ""
          ) {
            targetAmountt =
              parseInt(invTargetAmount.replace(/\D/g, ""), 10) || 0;
          }

          // const remainingMonth = (invGoalYear - invStartYear) * 12;

          let oneTimeInvFutureVal =
            aum * Math.pow(1 + invCagr / 100, invGoalYear - invStartYear);

          let capitalGrowth = 0;
          let monthEndValue = 0;
          let finalCorpus = 0;

          const totalSIP = (invrunningSIP || 0) + (newSIP || 0);

          // Loop to calculate monthly growth
          for (let i = 1; i <= remainingMonth; i++) {
            capitalGrowth = (monthEndValue + totalSIP) * (invCagr / 1200);
            monthEndValue += capitalGrowth + totalSIP;
          }

          monthEndValue += totalSIP;

          // Final corpus calculation
          finalCorpus =
            Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);

          if (finalCorpus < targetAmountt) {


            let selectedFund = "";
            let stpselectedFund = "";
            let stpselectedFund1 = "";
            let stpselectedFund2 = "";


            if (action == "STP") {
              // selectedFund = generateSipForm?.switchfundlist?.find((item) => item?.fund_name === stpfundName);
              //  selectedFund = await getFund(stpfundName)
            } else if (action == 'sip_stop') {
            } else if (action == 'Redeem') {
              selectedFund = amcNameList.find((item) => item?.fund_name === data?.fundNameRedeem);
              stpselectedFund = amcNameList.find((item) => item?.fund_name === data?.STP_fundName);
              stpselectedFund1 = amcNameList.find((item) => item?.fund_name === data?.STP_fundName1);
              stpselectedFund2 = amcNameList.find((item) => item?.fund_name === data?.STP_fundName2);
            }
            else if (action == 'Switch') {
              selectedFund = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.switchInFund);
              stpselectedFund = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.STP_fundName);
              stpselectedFund1 = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.STP_fundName1);
              stpselectedFund2 = generateSipForm?.switchfundlist.find((item) => item?.fund_name === data?.STP_fundName2);
            }

            const allData = {
              selectfund_sch_code: selectedFund?.scheme_code || "",
              STP_fundName_sch_code: stpselectedFund?.scheme_code || "",
              STP_fundName1_sch_code: stpselectedFund1?.scheme_code || "",
              STP_fundName2_sch_code: stpselectedFund2?.scheme_code || "",

              sipaction: action || "",
              allunites: data?.allUnitsRedeem || "",
              no_ofunites: 0 || "",
              reinvest: data.reInvest || "",
              goalName: invGoalName || "",
              limpsuamt: data.lumpSumAmountRedeem || "",
              selectfundhouse: data.amcHouseRedeem || "",
              selectfund: data.fundNameRedeem || "",
              lumpsuamtount: "",
              selectfundlumpsum: "",

              alluniteswitch: data.allUnitsSwitch || "",
              no_ofunites_switch: "",
              switchfund: data.switchInFund || "",
              swp_frequency: "",
              swp_amount: "",
              swp_startdate: "",
              swp_tenor: "",
              redeem_stp: data.stp || "",
              STP_Frequency: data.frequencySTP || data.stpSwitchFrequency || "",
              stplumpsumamount: "",
              stpdurationmonth:
                data.durationSTP || data.stpDurationMonthRedeem || "",
              STP_fundName: data.stpInFund || data.switchInFund || "",

              sipfundname: "",
              goalNameStart: generateSipForm?.goalName || "",
              // selectedStartDate ||
              sipstartdate: "",
              sipamount: data.sipAmountSIP || "",
              sipfrequency: "Monthly",
              sipPerpetual: "",
              sipenddate: "",

              // selectedStartDate ||
              stpstartdate: "",
              isreviewed: 1,

              siptypeaction: data?.sipaction || "",
              ...sipStopPayload,
              schemename: generateSipForm?.schemename || "",
              portfolioid: generateSipForm?.portfolioid || "",
              currentval: generateSipForm?.currentval || "",
              pan_client_id: str(generateSipForm.pan_client_id),
              clientid: generateSipForm?.clientid || "",
              ISIN: generateSipForm?.ISIN || "",
              isSIP: generateSipForm?.isSIP || "",
              moneyformatecurval: generateSipForm?.moneyformatecurval || "",

              fundname: generateSipForm?.fundname || "",
              startYear: invStartYear || "",
              goalYear: invGoalYear || "",
              goalNamePre: generateSipForm?.goalName || "",
              goalIdPre: generateSipForm?.goalId || "",
              act: "submit",
              test: "test2",

            };
            try {
              const response = await api.post(`advisor/saveportfolio`, allData);
              console.log("saveportfolio", response.data);
              if (response.data.message !== "") {
                Swal.fire({
                  title: "Success",
                  text: response.data.message,
                  icon: "success",
                  confirmButtonText: "OK",
                  customClass: {
                    confirmButton: "swal-confirm-btn",
                  },
                });
              }

              onHide();
              reset();

            } catch (error) {
              var diff = finalCorpus - invTargetAmount;
              Swal.fire({
                title: "Oops! Cannot exceed Goal Target",
                text:
                  "This investment will take the projected achievement to " +
                  finalCorpus +
                  ", which is " +
                  diff +
                  " higher than the Goal Target of " +
                  invTargetAmount +
                  ".",
                icon: "error",
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: "swal-confirm-btn",
                },
              });
            }
          } else {
            var diff = finalCorpus - invTargetAmount;
            Swal.fire({
              title: "Oops! Cannot exceed Goal Target",
              text:
                "This investment will take the projected achievement to " +
                finalCorpus +
                ", which is " +
                diff +
                " higher than the Goal Target of " +
                invTargetAmount +
                ".",
              icon: "error",
            });
          }
        }
        return;
      }
    } else {
      if (invGoalYear != "") {
      }

      let stp;
      let frequency;
      let duration;
      let lumpSumAmount;
      let stpfundName;
      let startDate;
      if (data?.sipaction === "STP") {
        stp = "yes";
        frequency = data.frequencySTP;

        if (frequencySTPW === "Weekly") {
          // setMinimumSTPinstallment(minMonthly * 4);
          duration = data.durationSTP * 4;
        } else {
          // setMinimumSTPinstallment(minMonthly);
          duration = data.durationSTP;
        }

        // if (duration < minimumSTPInstallment) {
        //   Swal.fire({
        //     title: "Error",
        //     text:
        //       `Minimum STP Duration for ${stpInFundW} can be ${minimumSTPInstallment}`,
        //     icon: "error",
        //     confirmButtonText: "OK",
        //     customClass: {
        //       confirmButton: "swal-confirm-btn",
        //     },
        //   });
        //   return
        // }

        if (duration < minimumSTPInstallment) {
          console.log('---------Hi error-----', duration, minimumSTPInstallment)
          // setError("durationSTP", {
          //   type: "manual",
          //   message: `Duration must be at least ${selectedFund.Minimum_SIP_Installment_Required} months.`,
          // });
          setError("durationSTP", {
            type: "manual",
            message: `Minimum STP Duration for ${stpInFundW} can be ${minimumSTPInstallment}`,
          });
          return;
        }


        lumpSumAmount = data.lumpSumAmountSTP;
        stpfundName = data.stpInFund;
        startDate = data.stpStartDate;
      } else if (data?.sipaction === "sip_stop") {
        stp = "yes";
        frequency = data.frequencySTP;
        duration = data.durationSTP;
        lumpSumAmount = data.lumpSumAmountSTP;
        stpfundName = data.stpInFund;
        startDate = data.stpStartDate;
      } else if (data?.sipaction === "Redeem") {
        stp = data.redeem_stp;
        frequency = data.STP_Frequency;
        duration = data.stpDurationMonthRedeem;
        lumpSumAmount = data.stplumpsumamount1;

        stpfundName = data.STP_fundName;
        startDate = data.stpRedeemstartDate;
      } else if (data?.sipaction === "Switch") {
        stp = data.stpSwitch;
        frequency = data.stpSwitchFrequency;
        duration = data.stpSwitchDuration;
        lumpSumAmount = data?.stpSwitchlumpSumAmount;
        // lumpSumAmount = data?.allUnitsSwitch === "no"? data?.transactionAmountSwitch : data?.stpSwitchlumpSumAmount;

        // lumpSumAmount =
        //   data?.allUnitsSwitch === "no"
        //     ? data?.transactionAmountSwitch
        //     : data?.redeemStp === "no"
        //     ? generateSipForm?.currentval
        //     : data?.stpSwitchlumpSumAmount;
        stpfundName = data.stpSwitchfundName;
        startDate = data.stpStartDateSwitch;
      }

      // Extract activesips object
      const activesips = (activeSips || []).reduce((acc, sip) => {
        if (
          String(sip?.type).toLowerCase() === "online" &&
          stopSipSelection?.[sip._id]
        ) {
          acc[sip._id] = sip.sip_amount;
        }

        return acc;
      }, {});

console.log("sipStopPayload", sipStopPayload);
      const allDataredeem = makePayload(action, data, generateSipForm, {
        activesips: selectedActiveSips,
        ...sipStopPayload,
        stp,
        stpfundName,
        duration,
        frequency,
        lumpSumAmount,
        startDate,
        stpRedeemstartDate1,
        stpRedeemstartDate2,
        invStartYear,
        invGoalYear,
        preGoalName,
      }, 'test4');


      console.log("allDataredeem", allDataredeem, data);
      // return;

      const limpsuamt = data.lumpSumAmountRedeem || "";
      const maxPurchaseAmount = Number(bseMaximumPurchaseAmount);

      if ((limpsuamt > maxPurchaseAmount) && (maxPurchaseAmount > 0)) {
        // console.log('---------Hi error-----', limpsuamt, bseMaximumPurchaseAmount)
        setError("lumpSumAmountRedeem", {
          type: "manual",
          message: `Maximum Lump Sum Amount for ${data.fundNameRedeem} can be ${maxPurchaseAmount}`,
        });
        return;
      }
      // sip allowed
      try {
        const response = await api.post(`advisor/saveportfolio`, allDataredeem);

        // console.log("saveportfolio redeem response",  response.data.errors.stpdurationmonth);

        // Handle validation errors
        if (
          response.data.status === false &&
          response.data.errors &&
          Object.keys(response.data.errors).length > 0
        ) {
          console.log("saveportfolio", response.data.errors);

          // ---------------switch--------------
          if (response.data.errors.no_ofunites_switch) {
            setError("transactionAmountSwitch", {
              type: "manual",
              message: response.data.errors.no_ofunites_switch,
            });
          } else {
            clearErrors("transactionAmountSwitch");
          }

          if (response.data.errors.stpdurationmonth) {
            setError("stpSwitchDuration", {
              type: "manual",
              message: response.data.errors.stpdurationmonth,
            });
          } else {
            clearErrors("stpSwitchDuration");
          }

          if (action === "Switch" && response.data.errors.stplumpsumamount) {
            setError("stpSwitchlumpSumAmount", {
              type: "manual",
              message: response.data.errors.stplumpsumamount,
            });
          } else {
            clearErrors("stpSwitchlumpSumAmount");
          }

          if (response.data.errors.no_ofunites) {
            setError("transactionAmountRedeem", {
              type: "manual",
              message: response.data.errors.no_ofunites,
            });
          } else {
            clearErrors("transactionAmountRedeem");
          }

          if (response.data.errors.switchfund) {
            setError("switchInFund", {
              type: "manual",
              message: response.data.errors.switchfund,
            });
          } else {
            clearErrors("switchInFund");
          }

          if (response.data.errors.stpdurationmonth) {
            setError("stpDurationMonthRedeem", {
              type: "manual",
              message: response.data.errors.stpdurationmonth,
            });
          } else {
            clearErrors("stpDurationMonthRedeem");
          }
          if (response.data.errors.STP_Frequency1) {
            setError("STP_Frequency1", {
              type: "manual",
              message: response.data.errors.STP_Frequency1,
            });
          } else {
            clearErrors("STP_Frequency1");
          }


          if (response.data.errors.stpdurationmonth1) {
            setError("stpdurationmonth1", {
              type: "manual",
              message: response.data.errors.stpdurationmonth1,
            });
          } else {
            clearErrors("stpdurationmonth1");
          }


          if (response.data.errors.STP_fundName1) {
            setError("STP_fundName1", {
              type: "manual",
              message: response.data.errors.STP_fundName1,
            });
          } else {
            clearErrors("STP_fundName1");
          }





          if (response.data.errors.limpsuamt) {
            setError("lumpSumAmountRedeem", {
              type: "manual",
              message: response.data.errors.limpsuamt,
            });
          } else {
            clearErrors("lumpSumAmountRedeem");
          }

          if (response.data.errors.stplumpsumamount) {
            setError("stplumpsumamount1", {
              type: "manual",
              message: response.data.errors.stplumpsumamount,
            });
          } else {
            clearErrors("stplumpsumamount1");
          }
          if (response.data.errors.stplumpsumamount1) {
            setError("stplumpsumamount11", {
              type: "manual",
              message: response.data.errors.stplumpsumamount1,
            });
          } else {
            clearErrors("stplumpsumamount11");
          }

          if (response.data.errors.STP_fundName) {
            setError("STP_fundName", {
              type: "manual",
              message: response.data.errors.STP_fundName,
            });
          } else {
            clearErrors("STP_fundName");
          }

          // ----redeem stp2------
          if (response.data.errors.stplumpsumamount2) {
            setError("stplumpsumamount12", {
              type: "manual",
              message: response.data.errors.stplumpsumamount2,
            });
          } else {
            clearErrors("stplumpsumamount12");
          }

          // -------------STP-----------

          if (action === "STP" && response.data.errors.stplumpsumamount) {
            setError("lumpSumAmountSTP", {
              type: "manual",
              message: response.data.errors.stplumpsumamount,
            });
          } else {
            clearErrors("lumpSumAmountSTP");
          }

          if (response.data.errors.stpdurationmonth) {
            setError("durationSTP", {
              type: "manual",
              message: response.data.errors.stpdurationmonth,
            });
          } else {
            clearErrors("durationSTP");
          }
        } else if (
          response.data.status === true
          //  &&
          // response.data.message !== ""
        ) {
          onHide(true);
          Swal.fire({
            title: "Success",
            icon: "success",
            html: response.data.message,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn",
            },
          }).then(() => {
            setIsActionMessage(response.data.message);
            onActionUpdate(
              rowKey,
              response.data.message,
              response.data.scheme_code
            );
            // onActionSchemeCode(rowKey, response.data.scheme_code);

            // fetchPortfolioData();     
            resetModalStates();
            onHide();
            reset();
          });
        }
      } catch (error) {
        console.error("Error saving portfolio:", error);

        // Optional: show user-friendly error alert
        Swal.fire({
          title: "Error",
          text:
            error?.response?.data?.message ||
            "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
      }


    }
  };

  const resetSTP2Fields = () => {
    setStpRedeemstartDate_2(null);
    setValue("redeem_stp1", "no");
    setValue("STP_fundName1", "");
    setValue("stpdurationmonth1", "");
    setValue("STP_Frequency1", "");
    setValue("stpstartdate1", "");
  };

  const resetSTP3Fields = () => {
    setStpRedeemstartDate_2(null);
    setValue("redeem_stp2", "no");
    setValue("STP_fundName2", "");
    setValue("stpdurationmonth2", "");
    setValue("STP_Frequency2", "");
    setValue("stpstartdate2", "");
  };

  const resetModalStates = () => {
    reset();
    resetSTP2Fields();
    resetSTP3Fields();
    setStpRedeemstartDate_1(null);
  };

  const handleClose = () => {
    onHide(true);
    reset();
    resetModalStates();
  };

  // const changeGoalName = (goalName) => {
  //   setValue("goalNameRedeem", goalName);
  //   console.log("goalName", goalName);
  // };

  // console.log("goalName-1", preData?.portfolio_id, preData?.portfolio_ISIN);

 
  useEffect(() => {
    setSipStopAnswer("");
    setStopSipSelection({});
  }, [ActionW, redeem_stpW, stpSwitchW]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      aria-labelledby="fundEditModal"
    >
      <Modal.Header closeButton>
        <div>
          <p className="fs-6 fw-bold m-0">{isLabel.selectectedtext1}</p>
          <p className="fs-6 fw-bold">{isLabel.selectectedtext2}</p>
        </div>
      </Modal.Header>
      {generateSipLoading ? (
        <Modal.Body
          className="d-flex align-items-center justify-content-center pb-4"
          style={{ minWidth: "50%" }}
        >
          <div
            className="spinner-border spinner-border-md text-success"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </Modal.Body>
      ) : (
        <Modal.Body>
          <Form
            onSubmit={handleSubmit(onSubmit, (formErrors) => {
              console.log("⛔ Validation failed with errors:", formErrors);
            })}
          >
            <Modal.Title
              id="fundEditModal"
              style={{
                fontSize: "16px",
                backgroundColor: "#23674B",
                color: "#fff",
                marginBottom: 20,
                padding: "10px",
                borderRadius: "10px",
                textAlign: "center", // Center align text
              }}
            >
              <div
                style={{ textAlign: "center" }} // Center align inner content
                className="px-4"
              >
                {actionName}
              </div>
            </Modal.Title>

            {/* Sipaction */}
            <Form.Group className="mb-3 mt-4">
              <Form.Label htmlFor="sipaction">Action</Form.Label>
              <Form.Select
                id="sipaction"
                {...register("sipaction", {
                  required: "Please select an option for sipaction.",
                })}
              >
                <option value="">Select Action</option>
                <option value="none">No Action Required</option>
                <option value="Redeem">Redeem</option>
                <option value="Switch">Switch</option>
                <option value="STP">STP</option>
                <option value="SIP">SIP</option>
                {clientreviewedfolioData?.portfolio_type_sip === 1 &&
                  preGoalName !== "Unmapped" && (
                    <option value="sip_stop">SIP Stop</option>
                  )}
              </Form.Select>
              {errors.sipaction && (
                <small className="text-danger">
                  {errors.sipaction.message}
                </small>
              )}
            </Form.Group>

            {ActionW === "Redeem" && (
              <>
                {/* All Units */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="allUnits">All Units</Form.Label>
                  <Form.Select
                    id="allUnits"
                    {...register("allUnitsRedeem", {
                      required: "This field is required.",
                    })}
                  // value={allUnits}
                  // onChange={(e) => {
                  //   setAllUnits(e.target.value);
                  //   setValue("allUnitsRedeem", e.target.value);
                  // }}
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </Form.Select>
                  {errors.allUnitsRedeem && (
                    <small className="text-danger">
                      {errors.allUnitsRedeem.message}
                    </small>
                  )}
                </Form.Group>

                {allUnitsRedeemW === "no" && (
                  <>
                    {/* Transaction Amount */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="transactionAmount">
                        Transaction Amount (Redeem Amount)
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="transactionAmount"
                        placeholder="Enter amount"
                        {...register("transactionAmountRedeem", {
                          required: "Transaction Amount is required.",
                          validate: (value) => {
                            const redeemAmount = Number(value);
                            const currentValue = Number(generateSipForm?.currentval);

                            if (value === "" || !Number.isFinite(redeemAmount)) {
                              return "Enter a valid redemption amount.";
                            }

                            if (redeemAmount <= 0) {
                              return "Redemption amount must be greater than zero.";
                            }

                            if (!Number.isFinite(currentValue) || currentValue < 0) {
                              return "Current fund value is unavailable.";
                            }

                            if (redeemAmount > currentValue) {
                              return `Redemption amount cannot exceed the current value of ₹${currentValue.toLocaleString("en-IN")}.`;
                            }

                            return true;
                          },
                        })}
                      />
                      {errors.transactionAmountRedeem && (
                        <small className="text-danger">
                          {errors.transactionAmountRedeem.message}
                        </small>
                      )}
                    </Form.Group>
                  </>
                )}

                {/* {allUnits === "yes" && ( */}
                <>
                  {/* Re-Invest */}
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="reInvest">Re-Invest</Form.Label>
                    <Form.Select
                      id="reInvest"
                      {...register("reInvest", {
                        required: "Re-Invest is required.",
                      })}
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </Form.Select>
                    {errors.reInvest && (
                      <small className="text-danger">
                        {errors.reInvest.message}
                      </small>
                    )}
                  </Form.Group>
                  {reInvestW === "yes" && (
                    <>
                      {/* Goal Name */}
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="goalNameRedeem">
                          Goal Name
                        </Form.Label>
                        <Form.Select
                          id="goalNameRedeem"
                          {...register("goalNameRedeem", {
                            required: "Goal Name is required.",
                          })}
                        // onChange={(e) => changeGoalName(e.target.value)}
                        >
                          {parsePortfolioOptions(
                            isPortfolioData?.options?.options
                          ).map((option) => (
                            <>
                              <option key={option.id} value={option.name}>
                                {option.name}
                              </option>
                            </>
                          ))}
                        </Form.Select>

                        {errors.goalNameRedeem && (
                          <small className="text-danger">
                            {errors.goalNameRedeem.message}
                          </small>
                        )}
                      </Form.Group>

                      {/* Lump Sum Amount */}
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="lumpSumAmountRedeem">
                          Lump Sum Amount
                        </Form.Label>
                        <Form.Control
                          type="text"
                          id="lumpSumAmountRedeem"
                          placeholder="Enter amount"
                          {...register("lumpSumAmountRedeem", {
                            required: "Lump Sum Amount is required.",
                            validate: (value) => {
                              const num = Number(value);
                              if (isNaN(num)) return "Lump Sum Amount must be a number";
                              if (num < 1) return "Amount must be at least 1";
                              return true;
                            },
                          })}
                        />
                        {errors.lumpSumAmountRedeem && (
                          <small className="text-danger">
                            {errors.lumpSumAmountRedeem.message}
                          </small>
                        )}
                      </Form.Group>

                      {/* AMC Name */}
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="amcName">AMC Name</Form.Label>
                        <Form.Select
                          id="amcHouse"
                          {...register("amcHouseRedeem", {
                            required: "AMC House is required.",
                          })}
                        >
                          <option value="">Select</option>
                          {/* Whitelisted Group */}
                          <optgroup label="Whitelisted">
                            {Object.values(amcName)
                              ?.filter((item) => item.Whitelisted === "true")
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={item.fund_house_name}
                                >
                                  {item.fund_house_name}
                                </option>
                              ))}
                          </optgroup>

                          {/* Non-Whitelisted Group */}
                          <optgroup label="Non-Whitelisted">
                            {Object.values(amcName)
                              ?.filter((item) => item.Whitelisted === "false")
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={item.fund_house_name}
                                >
                                  {item.fund_house_name}
                                </option>
                              ))}
                          </optgroup>
                        </Form.Select>
                        {errors.amcHouseRedeem && (
                          <small className="text-danger">
                            {errors.amcHouseRedeem.message}
                          </small>
                        )}
                      </Form.Group>

                      {/* Fund Name */}
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="fundName">Fund Name</Form.Label>
                        <Form.Select
                          id="fundName"
                          {...register("fundNameRedeem", {
                            required: "Fund Name is required.",
                          })}
                        >
                          <option value="">Select</option>
                          <>
                            <optgroup label="Whitelisted">
                              {amcNameList
                                ?.filter((item) => item?.Whitelisted === "true")
                                .map((item, index) => (
                                  <option key={index} value={item?.fund_name}>
                                    {item?.fund_name}
                                  </option>
                                ))}
                            </optgroup>
                            <optgroup label="Non-Whitelisted">
                              {amcNameList
                                ?.filter((item) => item?.Whitelisted === "false")
                                .map((item, index) => (
                                  <option key={index} value={item?.fund_name}>
                                    {item?.fund_name}
                                  </option>
                                ))}
                            </optgroup>
                          </>
                        </Form.Select>
                        {errors.fundNameRedeem && (
                          <small className="text-danger">
                            {errors.fundNameRedeem.message}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>+ STP ?</Form.Label>
                        <Form.Select
                          {...register("redeem_stp", {
                            required: "Please choose STP option.",
                          })}
                        // value={showSTP}
                        // onChange={(e) => {
                        //   setShowSTP(e.target.value);
                        //   setValue("redeem_stp", e.target.value);
                        // }}
                        >
                          <option value="">Select</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Form.Select>
                        {errors.redeem_stp && (
                          <small className="text-danger">
                            {errors.redeem_stp.message}
                          </small>
                        )}
                      </Form.Group>

                      {redeem_stpW === "yes" && (
                        <>
                          <Form.Group className="mb-3">
                            <Form.Label>STP Frequency</Form.Label>
                            <Form.Select
                              {...register("STP_Frequency", {
                                required: "STP Frequency is required.",
                              })}
                            >
                              <option value="">Select</option>
                              <option value="Monthly">Monthly</option>
                              <option value="Weekly">Weekly</option>
                            </Form.Select>
                            {errors.STP_Frequency && (
                              <small className="text-danger">
                                {errors.STP_Frequency.message}
                              </small>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>STP Duration</Form.Label>
                            <Form.Control
                              type="text"
                              {...register("stpDurationMonthRedeem", {
                                required: "STP Duration is required.",
                                validate: (value) => {
                                  const num = Number(value);
                                  if (isNaN(num)) return "STP Duration must be a number";
                                  if (num < 1) return "STP Duration must be at least 1";
                                  return true;
                                },
                              }
                              )}
                            />
                            {errors.stpDurationMonthRedeem && (
                              <small className="text-danger">
                                {errors.stpDurationMonthRedeem.message}
                              </small>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>Lump Sum </Form.Label>
                            <Form.Control
                              type="text"
                              {...register("stplumpsumamount1", {
                                required: "Lump Sum is required.",
                                validate: (value) => {
                                  const num = Number(value);
                                  if (isNaN(num)) return "Lump Sum must be a number";
                                  if (num < 1) return "Lump Sum must be at least 1";
                                  return true;
                                },
                              })}
                            />
                            {errors.stplumpsumamount1 && (
                              <small className="text-danger">
                                {errors.stplumpsumamount1.message}
                              </small>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>STP In Fund </Form.Label>
                            <Form.Select
                              {...register("STP_fundName", {
                                required: "STP In Fund is required.",
                                validate: (v) =>
                                  v !== fundNameRedeemW ||
                                  "STP In Fund cannot be the same as Fund Name.",
                              })}
                            >
                              <option value="">Select</option>

                              <>
                                <optgroup label="Whitelisted">
                                  {amcNameList
                                    .filter(
                                      (item) => item?.Whitelisted === "true"
                                    )
                                    .map((item, index) => (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={
                                          item?.fund_name === fundNameRedeemW
                                        }
                                      >
                                        {item?.fund_name}
                                      </option>
                                    ))}
                                </optgroup>

                                <optgroup label="Non-Whitelisted">
                                  {amcNameList
                                    .filter(
                                      (item) => item?.Whitelisted === "false"
                                    )
                                    .map((item, index) => (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={
                                          item?.fund_name === fundNameRedeemW
                                        }
                                      >
                                        {item?.fund_name}
                                      </option>
                                    ))}
                                </optgroup>
                              </>
                            </Form.Select>
                            {errors.STP_fundName && (
                              <small className="text-danger">
                                {errors.STP_fundName.message}
                              </small>
                            )}
                          </Form.Group>

                          <Form.Group
                            controlId="stpRedeemstartDate"
                            className="mb-3"
                          >
                            <Form.Label className="d-block">
                              STP Start Date
                            </Form.Label>
                            <Controller
                              name="stpRedeemstartDate"
                              control={control}
                              rules={{
                                required: "STP Start Date is required.",
                              }}
                              render={({ field }) => (
                                <DatePicker
                                  className="form-control w-100 "
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="STP Start Date"
                                  selected={field.value}
                                  onChange={field.onChange}
                                  minDate={new Date()}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                />
                              )}
                            />
                            {errors.stpRedeemstartDate && (
                              <small className="text-danger">
                                {errors.stpRedeemstartDate.message}
                              </small>
                            )}
                          </Form.Group>

                          {/* STP 2 Toggle */}

                          <Button
                            variant="outline-success"
                            type="button"
                            size="sm"
                            className="mb-2"
                            onClick={() => {
                              setValue("redeem_stp1", "yes");
                            }}
                          >
                            + STP?
                          </Button>

                          {/* STP 2 Fields */}
                          {redeem_stp1W === "yes" && (
                            <>
                              <Form.Group className="mb-3">
                                <Form.Label>STP Frequency </Form.Label>
                                <Form.Select
                                  {...register("STP_Frequency1")}


                                >
                                  <option value="">Select</option>
                                  <option value="Monthly">Monthly</option>
                                  <option value="Weekly">Weekly</option>
                                </Form.Select>
                                {errors.STP_Frequency1 && (
                                  <small className="text-danger">
                                    {errors.STP_Frequency1.message}
                                  </small>
                                )}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>STP Duration </Form.Label>
                                <Form.Control
                                  type="text"
                                  {...register("stpdurationmonth1", {
                                    required: "STP Duration is required.",
                                    validate: (value) => {
                                      const num = Number(value);
                                      if (isNaN(num)) return "STP Duration must be a number";
                                      if (num < 1) return "STP Duration must be at least 1";
                                      return true;
                                    }
                                  })}
                                />
                                {errors.stpdurationmonth1 && (
                                  <small className="text-danger">
                                    {errors.stpdurationmonth1.message}
                                  </small>
                                )}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>Lump Sum</Form.Label>
                                <Form.Control
                                  type="text"
                                  {...register("stplumpsumamount11", {
                                    required: "Lump Sum Amount is required.",
                                    validate: (value) => {
                                      const num = Number(value);
                                      if (isNaN(num)) return "Lump Sum Amount must be a number";
                                      if (num < 1) return "Lump Sum Amount must be at least 1";
                                      return true;
                                    },
                                  })}
                                />
                                {errors.stplumpsumamount11 && (
                                  <small className="text-danger">
                                    {errors.stplumpsumamount11.message}
                                  </small>
                                )}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>STP In Fund </Form.Label>
                                <Form.Select
                                  {...register("STP_fundName1", {
                                    // required: "STP In Fund is required.",
                                    validate: (v) => {
                                      if (v === fundNameRedeemW)
                                        return "Cannot be same as Redeem Fund.";
                                      if (v === watch("STP_fundName"))
                                        return "Cannot be same as 1st STP Fund.";
                                      return true;
                                    },
                                  })}
                                >
                                  <option value="">Select</option>
                                  <>
                                    <optgroup label="Whitelisted">
                                      {amcNameList
                                        .filter(
                                          (item) => item?.Whitelisted === "true"
                                        )
                                        .map((item, index) => (
                                          <option
                                            key={index}
                                            value={item?.fund_name}
                                            disabled={
                                              item?.fund_name ===
                                              fundNameRedeemW ||
                                              item?.fund_name ===
                                              watch("STP_fundName") // disable if selected already
                                            }
                                          >
                                            {item?.fund_name}
                                          </option>
                                        ))}
                                    </optgroup>

                                    <optgroup label="Non-Whitelisted">
                                      {amcNameList
                                        .filter(
                                          (item) =>
                                            item?.Whitelisted === "false"
                                        )
                                        .map((item, index) => (
                                          <option
                                            key={index}
                                            value={item?.fund_name}
                                            disabled={
                                              item?.fund_name ===
                                              fundNameRedeemW ||
                                              item?.fund_name ===
                                              watch("STP_fundName")
                                            }
                                          >
                                            {item?.fund_name}
                                          </option>
                                        ))}
                                    </optgroup>
                                  </>
                                </Form.Select>
                                {errors.STP_fundName1 && (
                                  <small className="text-danger">
                                    {errors.STP_fundName1.message}
                                  </small>
                                )}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>Start Date </Form.Label>
                                <DatePicker
                                  className="form-control"
                                  selected={stpRedeemstartDate1}
                                  onChange={handleRedeemStartDateChange1}
                                  minDate={new Date()}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                />
                              </Form.Group>

                              {/* Cancel STP2 */}
                              <Button
                                variant="outline-danger"
                                type="button"
                                className="me-2 mb-2"
                                size="sm"
                                onClick={resetSTP2Fields}
                              >
                                Cancel STP
                              </Button>

                              {/* STP3 Toggle */}
                              {redeem_stp2W !== "yes" && (
                                <Button
                                  variant="outline-success"
                                  type="button"
                                  size="sm"
                                  className="mb-2"
                                  onClick={(e) => {
                                    setValue("redeem_stp2", "yes");
                                  }}
                                >
                                  + STP?
                                </Button>
                              )}
                            </>
                          )}

                          {/* STP 3 Fields */}
                          {redeem_stp2W === "yes" && (
                            <>
                              <Form.Group className="mb-3">
                                <Form.Label>STP Frequency</Form.Label>
                                <Form.Select {...register("STP_Frequency2")}>
                                  <option value="">Select</option>
                                  <option value="Monthly">Monthly</option>
                                  <option value="Weekly">Weekly</option>
                                </Form.Select>
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>STP Duration </Form.Label>
                                <Form.Control
                                  type="text"
                                  {...register("stpdurationmonth2", {
                                    required: "STP Duration is required.",
                                    validate: (value) => {
                                      const num = Number(value);
                                      if (isNaN(num)) return "STP Duration must be a number";
                                      if (num < 1) return "STP Duration must be at least 1";
                                      return true;
                                    },
                                  })}
                                />
                                {errors.stpdurationmonth2 && (
                                  <small className="text-danger">
                                    {errors.stpdurationmonth2.message}
                                  </small>
                                )}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>Lump Sum</Form.Label>
                                <Form.Control
                                  type="text"
                                  {...register("stplumpsumamount12", {
                                    required: "Lump Sum Amount is required.",
                                    validate: (value) => {
                                      const num = Number(value);
                                      if (isNaN(num)) return "Lump Sum Amount must be a number";
                                      if (num < 1) return "Lump Sum Amount must be at least 1";
                                      return true;
                                    },
                                  })}
                                />
                                {errors.stplumpsumamount12 && (
                                  <small className="text-danger">
                                    {errors.stplumpsumamount12.message}
                                  </small>
                                )}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>STP In Fund</Form.Label>
                                <Form.Select
                                  {...register("STP_fundName2", {
                                    validate: (v) => {
                                      if (v === fundNameRedeemW)
                                        return "Cannot be same as Redeem Fund.";
                                      if (v === watch("STP_fundName"))
                                        return "Cannot be same as 1st STP Fund.";
                                      if (v === watch("STP_fundName1"))
                                        return "Cannot be same as 2nd STP Fund.";
                                      return true;
                                    },
                                  })}
                                >
                                  <option value="">Select</option>
                                  <>
                                    <optgroup label="Whitelisted">
                                      {amcNameList
                                        .filter(
                                          (item) => item?.Whitelisted === "true"
                                        )
                                        .map((item, index) => (
                                          <option
                                            key={index}
                                            value={item?.fund_name}
                                            disabled={
                                              item?.fund_name ===
                                              fundNameRedeemW ||
                                              item?.fund_name ===
                                              watch("STP_fundName") ||
                                              item?.fund_name ===
                                              watch("STP_fundName1")
                                            }
                                          >
                                            {item?.fund_name}
                                          </option>
                                        ))}
                                    </optgroup>

                                    <optgroup label="Non-Whitelisted">
                                      {amcNameList
                                        .filter(
                                          (item) =>
                                            item?.Whitelisted === "false"
                                        )
                                        .map((item, index) => (
                                          <option
                                            key={index}
                                            value={item?.fund_name}
                                            disabled={
                                              item?.fund_name ===
                                              fundNameRedeemW ||
                                              item?.fund_name ===
                                              watch("STP_fundName") ||
                                              item?.fund_name ===
                                              watch("STP_fundName1")
                                            }
                                          >
                                            {item?.fund_name}
                                          </option>
                                        ))}
                                    </optgroup>
                                  </>
                                </Form.Select>

                                {errors.STP_fundName2 && (
                                  <small className="text-danger">
                                    {errors.STP_fundName2.message}
                                  </small>
                                )}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>Start Date </Form.Label>
                                <DatePicker
                                  className="form-control"
                                  selected={stpRedeemstartDate2}
                                  onChange={handleRedeemStartDateChange2}
                                  minDate={new Date()}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                />
                              </Form.Group>
                              <Button
                                variant="outline-danger"
                                type="button"
                                className="my-2"
                                size="sm"
                                onClick={resetSTP3Fields}
                              >
                                Cancel STP
                              </Button>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
                {/* )} */}
              </>
            )}

            {/* --------------Switch-------------- */}
            {ActionW === "Switch" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="allUnitsSwitch">All Units</Form.Label>
                  <Form.Select
                    id="allUnits"
                    {...register("allUnitsSwitch", {
                      required: "This field is required.",
                    })}
                  // value={allUnits}
                  // onChange={(e) => {
                  //   setAllUnits(e.target.value);
                  //   setValue("allUnitsSwitch", e.target.value);
                  // }}
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </Form.Select>
                  {errors.allUnitsSwitch && (
                    <small className="text-danger">
                      {errors.allUnitsSwitch.message}
                    </small>
                  )}
                </Form.Group>

                {allUnitsSwitchW === "no" && (
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="transactionAmountSwitch">
                      Transaction Amount (Switch Amount)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="transactionAmountSwitch"
                      placeholder="Enter amount"
                      {...register("transactionAmountSwitch", {
                        required: "STP Duration is required.",
                        validate: (value) => {
                          const num = Number(value);
                          if (isNaN(num)) return "STP Duration must be a number";
                          if (num < 1) return "STP Duration must be at least 1";
                          return true;
                        }
                      })}
                    />
                    {errors.transactionAmountSwitch && (
                      <small className="text-danger">
                        {errors.transactionAmountSwitch.message}
                      </small>
                    )}
                  </Form.Group>
                )}

                {(allUnitsSwitchW === "yes" || allUnitsSwitchW === "no") &&
                  ActionW === "Switch" && (
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="switchInFund">
                        Select Switch In Fund
                      </Form.Label>
                      <Form.Select
                        id="switchInFund"
                        {...register("switchInFund", {
                          required: "Switch In Fund is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <>
                          <optgroup label="Same Folio Funds">
                            {/* {generateSipForm?.switchfundlist
                              .filter((item) => item?.ISIN === openSipFormAllData?.ISIN) // Check for string "true"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))} */}

                            {openSipFormAllData?.allSameFunds
                              ?.filter((item) => item?.ISIN !== openSipFormAllData?.ISIN)
                              .map((item, index) => (
                                <option key={index} value={item?.FundName}>
                                  {item?.FundName}
                                </option>
                              ))}
                          </optgroup>
                          <optgroup label="Whitelisted">
                            {generateSipForm?.switchfundlist
                              .filter((item) => item?.Whitelisted === "true") // Check for string "true"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>

                          <optgroup label="Non-Whitelisted">
                            {generateSipForm?.switchfundlist
                              .filter((item) => item?.Whitelisted === "false") // Check for string "false"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>
                        </>
                      </Form.Select>
                      {errors.switchInFund && (
                        <small className="text-danger">
                          {errors.switchInFund.message}
                        </small>
                      )}
                    </Form.Group>
                  )}

                {(allUnitsSwitchW === "yes" || allUnitsSwitchW === "no") &&
                  ActionW === "Switch" &&
                  switchInFundW !== null && (
                    <>
                      {/* stp */}
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="stp">+ STP?</Form.Label>
                        <Form.Select
                          id="stp"
                          {...register("stpSwitch", {
                            required:
                              "Please specify if you want to re-invest.",
                          })}

                          disabled={isStpSwitchDisabled}
                        >
                          <option value="">Select</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Form.Select>
                        {errors.stpSwitch && (
                          <small className="text-danger">
                            {errors.stpSwitch.message}
                          </small>
                        )}
                      </Form.Group>
                    </>
                  )}

                {stpSwitchW === "yes" && (
                  <>
                    {/* STP Frequency */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="stp">STP Frequency</Form.Label>
                      <Form.Select
                        id="stpFrequency"
                        {...register("stpSwitchFrequency", {
                          required: "STP Frequency is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Weekly">Weekly</option>
                      </Form.Select>
                      {errors.stpSwitchFrequency && (
                        <small className="text-danger">
                          {errors.stpSwitchFrequency.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP Duration (Months) */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="stpSwitchDuration">
                        STP Duration (Monthly)
                      </Form.Label>

                      <Form.Control
                        type="text"
                        id="stpSwitchDuration"
                        placeholder="Enter duration"
                        {...register("stpSwitchDuration", {
                          required: "STP Duration is required.",
                          validate: (value) => {
                            const num = Number(value);
                            if (isNaN(num)) return "STP Duration must be a number";
                            if (num < 1) return "STP Duration must be at least 1";
                            return true;
                          },
                        })}
                      />
                      {errors.stpSwitchDuration && (
                        <small className="text-danger">
                          {errors.stpSwitchDuration.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP Lump Sum Amount */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="stplumpSumAmount">
                        Lump Sum Amount
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="stplumpSumAmount"
                        placeholder="Enter amount"
                        {...register("stpSwitchlumpSumAmount", {
                          required: "Lump Sum Amount is required.",
                          validate: (value) => {
                            const num = Number(value);
                            if (isNaN(num)) return "Lump Sum Amount must be a number";
                            if (num < 1) return "Lump Sum Amount must be at least 1";
                            return true;
                          },
                        })}
                      />
                      {errors.stpSwitchlumpSumAmount && (
                        <small className="text-danger">
                          {errors.stpSwitchlumpSumAmount.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP Switch fundName */}
                    {/* <Form.Group className="mb-3">
                      <Form.Label>STP In Fund </Form.Label>
                      <Form.Select
                        {...register("stpSwitchfundName", {
                          required: "STP Fund is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <>
                          <optgroup label="Whitelisted">
                            {generateSipForm?.switchfundlist
                              .filter((item) => item?.Whitelisted === "true") // Check for string "true"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>

                          <optgroup label="Non-Whitelisted">
                            {generateSipForm?.switchfundlist
                              .filter((item) => item?.Whitelisted === "false") // Check for string "false"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>
                        </>
                      </Form.Select>
                      {errors.stpSwitchfundName && (
                        <small className="text-danger">
                          {errors.stpSwitchfundName.message}
                        </small>
                      )}
                    </Form.Group> */}

                    <Form.Group className="mb-3">
                      <Form.Label>STP In Fund</Form.Label>
                      <Form.Select
                        {...register("stpSwitchfundName", {
                          required: "STP Fund is required.",
                          validate: (v) =>
                            v === watch("switchInFund")
                              ? "STP Fund cannot be the same as Switch In Fund."
                              : true,
                        })}
                      >
                        <option value="">Select</option>
                        <>
                          <optgroup label="Whitelisted">
                            {generateSipForm?.switchfundlist
                              .filter((item) => item?.Whitelisted === "true")
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={item?.fund_name}
                                  disabled={
                                    item?.fund_name === watch("switchInFund")
                                  }
                                >
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>

                          <optgroup label="Non-Whitelisted">
                            {generateSipForm?.switchfundlist
                              .filter((item) => item?.Whitelisted === "false")
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={item?.fund_name}
                                  disabled={
                                    item?.fund_name === watch("switchInFund")
                                  }
                                >
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>
                        </>
                      </Form.Select>

                      {errors.stpSwitchfundName && (
                        <small className="text-danger">
                          {errors.stpSwitchfundName.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP Start Date */}
                    <Form.Group controlId="stpStartDate" className="mb-3">
                      <Form.Label className="d-block">
                        Select STP Start Date
                      </Form.Label>
                      <Controller
                        name="stpStartDateSwitch"
                        control={control}
                        rules={{ required: "STP Start Date is required." }}
                        render={({ field }) => (
                          <DatePicker
                            className="form-control w-100 "
                            dateFormat="dd-MM-yyyy"
                            placeholderText="STP Start Date"
                            selected={field.value}
                            onChange={field.onChange}
                            minDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        )}
                      />
                      {errors.stpStartDateSwitch && (
                        <small className="text-danger">
                          {errors.stpStartDateSwitch.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP 2 Toggle */}

                    {/* STP1 Button */}
                    {redeem_stp1W !== "yes" && (
                      <Button
                        variant="outline-success"
                        type="button"
                        size="sm"
                        className="mb-2 me-2"
                        disabled={!isSTP1Enabled}
                        onClick={() => {
                          setValue("redeem_stp1", "yes");
                        }}
                      >
                        + STP?
                      </Button>
                    )}

                    {/* STP 2 Fields */}
                    {redeem_stp1W === "yes" && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>STP Frequency </Form.Label>
                          <Form.Select {...register("STP_Frequency1")}>
                            <option value="">Select</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                          </Form.Select>
                          {errors.STP_Frequency1 && (
                            <small className="text-danger">
                              {errors.STP_Frequency1.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP Duration </Form.Label>
                          <Form.Control
                            type="text"
                            {...register("stpdurationmonth1", {
                              required: "STP Duration is required.",
                              validate: (value) => {
                                const num = Number(value);
                                if (isNaN(num)) return "STP Duration must be a number";
                                if (num < 1) return "STP Duration must be at least 1";
                                return true;
                              },
                            })}
                          />
                          {errors.stpdurationmonth1 && (
                            <small className="text-danger">
                              {errors.stpdurationmonth1.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Lump Sum</Form.Label>
                          <Form.Control
                            type="text"
                            {...register("stplumpsumamount11", {
                              required: "Lump Sum amount is required.",
                              validate: (value) => {
                                const num = Number(value);
                                if (isNaN(num)) return "Lump Sum amount must be a number";
                                if (num < 1) return "Lump Sum amount must be at least 1";
                                return true;
                              },
                            })}
                          />
                          {errors.stplumpsumamount11 && (
                            <small className="text-danger">
                              {errors.stplumpsumamount11.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP In Fund</Form.Label>
                          <Form.Select
                            {...register("STP_fundName1", {
                              // required: "STP In Fund is required.",
                              validate: (v) => {
                                if (v === watch("stpSwitchfundName"))
                                  return "Cannot be same as STP Switch Fund.";
                                if (v === watch("switchInFund"))
                                  return "Cannot be same as Switch In Fund.";
                                return true;
                              },
                            })}
                          >
                            <option value="">Select</option>

                            <>
                              <optgroup label="Whitelisted">
                                {generateSipForm?.switchfundlist
                                  .filter(
                                    (item) => item?.Whitelisted === "true"
                                  )
                                  .map((item, index) => {
                                    const isDisabled =
                                      item?.fund_name ===
                                      watch("stpSwitchfundName") ||
                                      item?.fund_name === watch("switchInFund");
                                    return (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={isDisabled}
                                      >
                                        {item?.fund_name}
                                      </option>
                                    );
                                  })}
                              </optgroup>

                              <optgroup label="Non-Whitelisted">
                                {generateSipForm?.switchfundlist
                                  .filter(
                                    (item) => item?.Whitelisted === "false"
                                  )
                                  .map((item, index) => {
                                    const isDisabled =
                                      item?.fund_name ===
                                      watch("stpSwitchfundName") ||
                                      item?.fund_name === watch("switchInFund");
                                    return (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={isDisabled}
                                      >
                                        {item?.fund_name}
                                      </option>
                                    );
                                  })}
                              </optgroup>
                            </>
                          </Form.Select>

                          {errors.STP_fundName1 && (
                            <small className="text-danger">
                              {errors.STP_fundName1.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Start Date </Form.Label>
                          <DatePicker
                            className="form-control"
                            selected={stpRedeemstartDate1}
                            onChange={handleRedeemStartDateChange1}
                            minDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </Form.Group>

                        {/* Cancel STP2 */}
                        <Button
                          variant="outline-danger"
                          type="button"
                          className="me-2 mb-2"
                          size="sm"
                          onClick={resetSTP2Fields}
                        >
                          Cancel STP
                        </Button>

                        {/* STP3 Toggle */}
                        {/* STP2 Button */}
                        {redeem_stp2W !== "yes" && (
                          <Button
                            variant="outline-success"
                            type="button"
                            size="sm"
                            className="mb-2"
                            disabled={!isSTP2Enabled}
                            onClick={() => {
                              setValue("redeem_stp2", "yes");
                            }}
                          >
                            + STP?
                          </Button>
                        )}
                      </>
                    )}

                    {/* STP 3 Fields */}
                    {redeem_stp2W === "yes" && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>STP Frequency</Form.Label>
                          <Form.Select {...register("STP_Frequency2")}>
                            <option value="">Select</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                          </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP Duration </Form.Label>
                          <Form.Control
                            type="text"
                            {...register("stpdurationmonth2", {
                              required: "STP Duration is required.",
                              validate: (value) => {
                                const num = Number(value);
                                if (isNaN(num)) return "STP Duration must be a number";
                                if (num < 1) return "STP Duration must be at least 1";
                                return true;
                              },
                            })}
                          />
                          {errors.stpdurationmonth2 && (
                            <small className="text-danger">
                              {errors.stpdurationmonth2.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Lump Sum</Form.Label>
                          <Form.Control
                            type="text"
                            {...register("stplumpsumamount12", {
                              required: "Lump Sum Amount is required.",
                              validate: (value) => {
                                const num = Number(value);
                                if (isNaN(num)) return "Lump Sum Amount must be a number";
                                if (num < 1) return "Lump Sum Amount must be at least 1";
                                return true;
                              },
                            })}
                          />
                          {errors.stplumpsumamount12 && (
                            <small className="text-danger">
                              {errors.stplumpsumamount12.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP In Fund</Form.Label>
                          <Form.Select
                            {...register("STP_fundName2", {
                              // required: "STP In Fund is required.",
                              validate: (v) => {
                                if (v === watch("switchInFund"))
                                  return "Cannot be same as Switch In Fund.";
                                if (v === watch("stpSwitchfundName"))
                                  return "Cannot be same as STP Switch Fund.";
                                if (v === watch("STP_fundName1"))
                                  return "Cannot be same as STP In Fund 1.";
                                return true;
                              },
                            })}
                          >
                            <option value="">Select</option>
                            <>
                              <optgroup label="Whitelisted">
                                {generateSipForm?.switchfundlist
                                  .filter(
                                    (item) => item?.Whitelisted === "true"
                                  )
                                  .map((item, index) => {
                                    const isDisabled =
                                      item?.fund_name ===
                                      watch("switchInFund") ||
                                      item?.fund_name ===
                                      watch("stpSwitchfundName") ||
                                      item?.fund_name ===
                                      watch("STP_fundName1");

                                    return (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={isDisabled}
                                      >
                                        {item?.fund_name}
                                      </option>
                                    );
                                  })}
                              </optgroup>

                              <optgroup label="Non-Whitelisted">
                                {generateSipForm?.switchfundlist
                                  .filter(
                                    (item) => item?.Whitelisted === "false"
                                  )
                                  .map((item, index) => {
                                    const isDisabled =
                                      item?.fund_name ===
                                      watch("switchInFund") ||
                                      item?.fund_name ===
                                      watch("stpSwitchfundName") ||
                                      item?.fund_name ===
                                      watch("STP_fundName1");

                                    return (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={isDisabled}
                                      >
                                        {item?.fund_name}
                                      </option>
                                    );
                                  })}
                              </optgroup>
                            </>
                          </Form.Select>

                          {errors.STP_fundName2 && (
                            <small className="text-danger">
                              {errors.STP_fundName2.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Start Date </Form.Label>
                          <DatePicker
                            className="form-control"
                            selected={stpRedeemstartDate2}
                            onChange={handleRedeemStartDateChange2}
                            minDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </Form.Group>
                        <Button
                          variant="outline-danger"
                          type="button"
                          className="my-2"
                          size="sm"
                          onClick={resetSTP3Fields}
                        >
                          Cancel STP
                        </Button>
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {/* --------------STP-------------- */}
            {ActionW === "STP" && (
              <>
                {/* STP Frequency */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="stp">STP Frequency</Form.Label>
                  <Form.Select
                    id="stpFrequency"
                    {...register("frequencySTP", {
                      required: "STP Frequency required.",
                    })}
                  >
                    <option value="">Select</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Weekly">Weekly</option>
                  </Form.Select>
                  {errors.frequencySTP && (
                    <small className="text-danger">
                      {errors.frequencySTP.message}
                    </small>
                  )}
                </Form.Group>

                {/* STP Duration (Months) */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="transactionAmount">
                    {/* STP Duration ({frequencySTPW}) */}
                    STP Duration (Monthly)

                  </Form.Label>

                  <Form.Control
                    type="text"
                    id="stpDuration"
                    placeholder=""
                    {...register("durationSTP", {
                      required: "Duration is required.",
                      min: { value: 1, message: "Amount must be at least 1." },
                    })}
                  />
                  {errors.durationSTP && (
                    <small className="text-danger">
                      {errors.durationSTP.message}
                    </small>
                  )}
                </Form.Group>
                {/* Lump Sum Amount */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="lumpSumAmountSTP">
                    Lump Sum Amount
                  </Form.Label>
                  <Form.Control
                    type="text"
                    id="lumpSumAmountSTP"
                    placeholder="Enter amount"
                    {...register("lumpSumAmountSTP", {
                      required: "Lump Sum Amount is required.",
                      validate: (value) => {
                        const num = Number(value);
                        if (isNaN(num)) return "Lump Sum Amount must be a number";
                        if (num < 1) return "Lump Sum Amount must be at least 1";
                        return true;
                      },
                    })}
                  />
                  {errors.lumpSumAmountSTP && (
                    <small className="text-danger">
                      {errors.lumpSumAmountSTP.message}
                    </small>
                  )}
                </Form.Group>

                {/* Select STP In Fund */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="stpInFund">
                    Select STP In Fund
                  </Form.Label>
                  <Form.Select
                    id="stpInFund"
                    // value={isSwitchInFund}
                    {...register("stpInFund", {
                      required: "Stp In Fund is required.",
                    })}
                  // onChange={(e) => {
                  //   // setSwitchInFund(e.target.value);
                  //   setValue("stpInFund", e.target.value);
                  // }}
                  >
                    <option value="">Select</option>
                    <>
                      <optgroup label="Whitelisted">
                        {generateSipForm?.switchfundlist
                          .filter((item) => item?.Whitelisted === "true") // Check for string "true"
                          .map((item, index) => (
                            <option key={index} value={item?.fund_name}>
                              {item?.fund_name}
                            </option>
                          ))}
                      </optgroup>

                      <optgroup label="Non-Whitelisted">
                        {generateSipForm?.switchfundlist
                          .filter((item) => item?.Whitelisted === "false") // Check for string "false"
                          .map((item, index) => (
                            <option key={index} value={item?.fund_name}>
                              {item?.fund_name}
                            </option>
                          ))}
                      </optgroup>
                    </>
                  </Form.Select>
                  {errors.stpInFund && (
                    <small className="text-danger">
                      {errors.stpInFund.message}
                    </small>
                  )}
                </Form.Group>

                {/* STP Start Date */}
                <Form.Group controlId="stpStartDate" className="mb-3">
                  <Form.Label className="d-block">
                    Select STP Start Date
                  </Form.Label>
                  <Controller
                    name="stpStartDate"
                    control={control}
                    rules={{ required: "STP Start Date is required." }}
                    render={({ field }) => (
                      <DatePicker
                        className="form-control w-100 "
                        dateFormat="dd-MM-yyyy"
                        placeholderText="STP Start Date"
                        selected={field.value}
                        onChange={field.onChange}
                        minDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                      />
                    )}
                  />
                  {errors.stpStartDate && (
                    <small className="text-danger">
                      {errors.stpStartDate.message}
                    </small>
                  )}
                </Form.Group>
              </>
            )}

            {/* --------SIP STOP------------*/}
            
            {showSipStopAfterStp && (
              <Form.Group className="mt-3">
                <Form.Label>Do you want to stop SIP?</Form.Label>

                <div>
                  <Form.Check
                    inline
                    type="radio"
                    name="sipStopAnswer"
                    label="Yes"
                    value="yes"
                    checked={sipStopAnswer === "yes"}
                    onChange={() => setSipStopAnswer("yes")}
                  />

                  <Form.Check
                    inline
                    type="radio"
                    name="sipStopAnswer"
                    label="No"
                    value="no"
                    checked={sipStopAnswer === "no"}
                    onChange={() => setSipStopAnswer("no")}
                  />
                </div>
              </Form.Group>
            )}


            {/* --------------SIP-------------- */}
            {ActionW === "SIP" && (
              <>
                {/* Goal Name */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="goalNameSIP">Goal Name</Form.Label>
                  <Form.Control
                    id="goalNameSIP"
                    type="text"
                    readOnly
                    {...register("goalNameSIP", {
                      required: "Goal Name is required.",
                    })}
                  // dangerouslySetInnerHTML={{
                  //   __html: isPortfolioData?.options?.options,
                  // }}
                  ></Form.Control>
                  {errors.goalNameSIP && (
                    <small className="text-danger">
                      {errors.goalNameSIP.message}
                    </small>
                  )}
                </Form.Group>

                {/* SIP Start Date */}
                <Form.Group controlId="sipStartDate" className="mb-3">
                  <Form.Label className="d-block">SIP Start Date</Form.Label>
                  <Controller
                    name="sipStartDate"
                    control={control}
                    rules={{ required: "SIP Start Date is required." }}
                    render={({ field }) => (
                      <DatePicker
                        className="form-control w-100 "
                        dateFormat="dd-MM-yyyy"
                        placeholderText="SIP Start Date"
                        selected={field.value}
                        onChange={field.onChange}
                        // minDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        minDate={new Date(new Date().setDate(new Date().getDate() + 2))}
                      />
                    )}
                  />
                  {errors.sipStartDate && (
                    <small className="text-danger">
                      {errors.sipStartDate.message}
                    </small>
                  )}
                </Form.Group>

                {/* Sip Amount */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="sipAmount">SIP Amount</Form.Label>

                  {/* <Form.Control
                    type="text"
                    id="sipAmount"
                    placeholder="Enter SIP Amount"
                    {...register("sipAmountSIP", {
                      required: "Sip Amountis required.",
                      min: { value: 1, message: "Amount must be at least 1." },
                    })}
                  /> */}
                  <Form.Control
                    type="text"
                    id="sipAmount"
                    placeholder="Enter SIP Amount"
                    {...register("sipAmountSIP", {
                      required: "SIP Amount is required.",
                      validate: (value) => {
                        const num = Number(value);
                        if (isNaN(num)) return "SIP Amount must be a number";
                        if (num < 1) return "Amount must be at least 1";
                        return true;
                      },
                    })}
                  />

                  {errors.sipAmountSIP && (
                    <small className="text-danger">
                      {errors.sipAmountSIP.message}
                    </small>
                  )}
                </Form.Group>

                {/* Perpetual SIP */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="perpetualSIP">Perpetual SIP?</Form.Label>
                  <Form.Select
                    id="perpetualSIP"
                    {...register("perpetualSIP", {
                      required: "Perpetual SIP required",
                    })}
                  // value={isPerpetualSIP}
                  // onChange={(e) => {
                  //   setIsPerpetualSIP(e.target.value);
                  //   setValue("perpetualSIP", e.target.value); // Update react-hook-form value
                  // }}
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </Form.Select>
                  {errors.perpetualSIP && (
                    <small className="text-danger">
                      {errors.perpetualSIP.message}
                    </small>
                  )}
                </Form.Group>

                {perpetualSIPW === "no" && (
                  <>
                    {/* SIP End Date */}
                    <Form.Group controlId="sipEndDate" className="mb-3">
                      <Form.Label className="d-block">SIP End Date</Form.Label>
                      <Controller
                        name="sipEndDate"
                        control={control}
                        rules={{ required: "SIP End Date is required." }}
                        render={({ field }) => (
                          <DatePicker
                            className="form-control w-100 "
                            dateFormat="dd-MM-yyyy"
                            placeholderText="SIP End Date"
                            selected={field.value}
                            onChange={field.onChange}
                            minDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        )}
                      />
                      {errors.sipEndDate && (
                        <small className="text-danger">
                          {errors.sipEndDate.message}
                        </small>
                      )}
                    </Form.Group>
                  </>
                )}
              </>
            )}

            {/* ---------SIP Stop-------- */}
              {(
                ActionW === "sip_stop" ||
                (showSipStopAfterStp && sipStopAnswer === "yes")
              ) && (
              <>
                {/* Active SIPs list (checkboxes) */}
                {Array.isArray(activeSips) && activeSips.length > 0 ? (
                  <div className="mb-3">
                    <div className="row fw-bold px-2">
                      <div className="col-md-2">Mode</div>
                      <div className="col-md-2">Amt</div>
                      <div className="col-md-3">ECS Date</div>
                      <div className="col-md-4">Bank Details</div>
                      <div className="col-md-1">Stop?</div>
                    </div>
                    {activeSips.map((s) => {
                      const last4 =
                        (s?.sip_bank_account || "").slice(
                          Math.max(0, (s?.sip_bank_account || "").length - 4)
                        ) || "";
                      const disabled =
                        String(s?.type).toLowerCase() !== "online";
                      // console.log('ss',s);
                      console.log("isLable", generateSipForm?.sipdata, stopSipSelection, activeSips);

                      return (
                        <div
                          className="row align-items-center px-2 py-1"
                          key={s._id}
                        >
                          <div className="col-md-2">{s?.type}</div>
                          <div className="col-md-2">{s?.sip_amount}</div>
                          <div className="col-md-3">
                            {formatOrdinalDate(s?.sip_startdate)}
                            {/* show date as '1st', '2nd' (matching PHP) or fallback */}
                            {/* {s?.sip_startdata
                              ? new Date(s.sip_startdata).toLocaleString(
                                "en-GB",
                                {
                                  day: "numeric",
                                }
                              ) + " (ECS)"
                              : "-"} */}
                          </div>
                          <div className="col-md-4">
                            {(s?.sip_bank_name || "").slice(0, 10)} / {last4}
                          </div>
                          <div className="col-md-1">
                            <Form.Check
                              type="checkbox"
                              disabled={disabled}
                              checked={!!stopSipSelection[s._id]}
                              onChange={(e) =>
                                toggleStopSip(s._id, e.target.checked)
                              }
                            />
                          </div>
                        </div>
                      );
                    })}
                    {/* Require at least one selected SIP */}
                    {Object.values(stopSipSelection).some(Boolean) ? null : (
                      <small className="text-danger">
                        Select at least one online SIP to stop.
                      </small>
                    )}
                  </div>
                ) : (
                  <p className="text-muted">No active SIPs found.</p>
                )}
                {stopSipSelection &&
                  Object.values(stopSipSelection).some(Boolean) && (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="startasip">
                          Re-start a SIP?
                        </Form.Label>
                        <Form.Select
                          id="startasip"
                          {...register("startasip", {
                            required: " Re-start a SIP is required.",
                          })}
                        >
                          <option value="">Select</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Form.Select>
                        {errors.startasip && (
                          <small className="text-danger">
                            {errors.startasip.message}
                          </small>
                        )}
                      </Form.Group>
                      {startasipW && startasipW === "yes" && (
                        <>
                          {/* AMC Name */}
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="amcName">AMC Name</Form.Label>
                            <Form.Select
                              id="amcHouse"
                              {...register("stopsip_amc", {
                                required: "AMC House is required.",
                                onChange: async (e) => {
                                  const selectedAMC = e.target.value;

                                  setValue("restartfundname", "");
                                  setRestartSipFundList([]);

                                  if (!selectedAMC) return;

                                  try {
                                    const response = await api.get(
                                      `advisor/amc_fund_by_house?house_name=${encodeURIComponent(selectedAMC)}`
                                    );

                                    setRestartSipFundList(
                                      Array.isArray(response.data) ? response.data : []
                                    );
                                  } catch (error) {
                                    console.error("Error fetching Restart SIP funds:", error);
                                  }
                                },
                              })}
                            >
                              <option value="">Select</option>
                              {/* Whitelisted Group */}
                              <optgroup label="Whitelisted">
                                {Object.values(amcName)
                                  ?.filter(
                                    (item) => item.Whitelisted === "true"
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={item.fund_house_name}
                                    >
                                      {item.fund_house_name}
                                    </option>
                                  ))}
                              </optgroup>

                              {/* Non-Whitelisted Group */}
                              <optgroup label="Non-Whitelisted">
                                {Object.values(amcName)
                                  ?.filter(
                                    (item) => item.Whitelisted === "false"
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={item.fund_house_name}
                                    >
                                      {item.fund_house_name}
                                    </option>
                                  ))}
                              </optgroup>
                            </Form.Select>
                            {errors.stopsip_amc && (
                              <small className="text-danger">
                                {errors.stopsip_amc.message}
                              </small>
                            )}
                          </Form.Group>

                          {/* Fund Name */}
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="fundName">
                              Fund Name
                            </Form.Label>

                            <Form.Select
                              id="fundName"
                              {...register("restartfundname", {
                                required: "Fund Name is required.",
                              })}
                            >
                              <option value="">Select</option>

                              <optgroup label="Whitelisted">
                                {restartSipFundList
                                  .filter((item) => item?.Whitelisted === "true")
                                  .map((item, index) => (
                                    <option key={index} value={item?.fund_name}>
                                      {item?.fund_name}
                                    </option>
                                  ))}
                              </optgroup>

                              <optgroup label="Non-Whitelisted">
                                {restartSipFundList
                                  .filter((item) => item?.Whitelisted === "false")
                                  .map((item, index) => (
                                    <option key={index} value={item?.fund_name}>
                                      {item?.fund_name}
                                    </option>
                                  ))}
                              </optgroup>
                            </Form.Select>

                            {errors.restartfundname && (
                              <small className="text-danger">
                                {errors.restartfundname.message}
                              </small>
                            )}
                          </Form.Group>

                          {/* Goal Name */}
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="goalNameSIP">
                              Goal Name
                            </Form.Label>
                            <Form.Control
                              id="goalNameSIP"
                              type="text"
                              readOnly
                              {...register("goalNameSIP", {
                                required: "Goal Name is required.",
                              })}
                            ></Form.Control>
                            {errors.goalNameSIP && (
                              <small className="text-danger">
                                {errors.goalNameSIP.message}
                              </small>
                            )}
                          </Form.Group>

                          {/* SIP Start Date */}
                          <Form.Group controlId="sipStartDate" className="mb-3">
                            <Form.Label className="d-block">
                              SIP Start Date
                            </Form.Label>
                            <Controller
                              name="sipStartDate"
                              control={control}
                              rules={{
                                required: "SIP Start Date is required.",
                              }}
                              render={({ field }) => (
                                <DatePicker
                                  className="form-control w-100 "
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="SIP Start Date"
                                  selected={field.value}
                                  onChange={field.onChange}
                                  minDate={new Date()}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                />
                              )}
                            />
                            {errors.sipStartDate && (
                              <small className="text-danger">
                                {errors.sipStartDate.message}
                              </small>
                            )}
                          </Form.Group>

                          {/* Sip Amount */}
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="sipAmount">
                              SIP Amount
                            </Form.Label>

                            <Form.Control
                              type="text"
                              id="sipAmount"
                              placeholder="Enter SIP Amount"
                              {...register("sipAmountSIP", {
                                required: "Sip Amountis required.",
                                min: {
                                  value: 1,
                                  message: "Amount must be at least 1.",
                                },
                              })}
                            />
                            {errors.sipAmountSIP && (
                              <small className="text-danger">
                                {errors.sipAmountSIP.message}
                              </small>
                            )}
                          </Form.Group>

                          {/* Perpetual SIP */}
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="perpetualSIP">
                              Perpetual SIP?
                            </Form.Label>
                            <Form.Select
                              id="perpetualSIP"
                              {...register("perpetualSIP", {
                                required: "Perpetual SIP required",
                              })}
                            >
                              <option value="">Select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </Form.Select>
                            {errors.perpetualSIP && (
                              <small className="text-danger">
                                {errors.perpetualSIP.message}
                              </small>
                            )}
                          </Form.Group>

                          {perpetualSIPW === "no" && (
                            <>
                              {/* SIP End Date */}
                              <Form.Group
                                controlId="sipEndDate"
                                className="mb-3"
                              >
                                <Form.Label className="d-block">
                                  SIP End Date
                                </Form.Label>
                                <Controller
                                  name="sipEndDate"
                                  control={control}
                                  rules={{
                                    required: "SIP End Date is required.",
                                  }}
                                  render={({ field }) => (
                                    <DatePicker
                                      className="form-control w-100 "
                                      dateFormat="dd-MM-yyyy"
                                      placeholderText="SIP End Date"
                                      selected={field.value}
                                      onChange={field.onChange}
                                      minDate={new Date()}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                    />
                                  )}
                                />
                                {errors.sipEndDate && (
                                  <small className="text-danger">
                                    {errors.sipEndDate.message}
                                  </small>
                                )}
                              </Form.Group>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
              </>
            )}

            {/* Submit Button */}
            <Button
              variant="success"
              type="submit"
              className="w-100"
            // disabled={!isValid}
            >
              Update
            </Button>
          </Form>

          <FundDetailsModal
            show={showModal}
            onHide={() => setShowModal(false)}
            content={modalContent}
          />
        </Modal.Body>
      )}
    </Modal>
  );
};
